/* eslint no-underscore-dangle: 0 */

import {
  ClassicEditor,
  AutoImage,
  BlockQuote,
  Bold,
  Essentials,
  Heading,
  ImageBlock,
  ImageCaption,
  ImageInline,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  ListProperties,
  Paragraph,
  SimpleUploadAdapter,
  TextTransformation,
} from 'ckeditor5';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  FormControl,
  Grid,
  List as MuiList,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@material-ui/core';
import { createFilterOptions } from '@mui/material/Autocomplete';

import CancelIcon from '@material-ui/icons/Cancel';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { Formik } from 'formik';
import _, { filter, isEmpty } from 'lodash';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import toast from 'react-hot-toast';
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from 'react-router-dom';
import { casesApi } from 'src/api/casesApi';
import { translationApi } from 'src/api/translationApi';
import { userApi } from 'src/api/userApi';
import MultiFileLinkInputCase from 'src/components/MultiFileLinkInputCase';
import SimpleBreadCrumb from 'src/components/widgets/BreadCrumb/SimpleBreadCrumb';
import CustomButton from 'src/components/widgets/buttons/CustomButton';
import FileUploadDragDrop from 'src/components/widgets/fileUpload/FileUploadDragDrop';
import DocumentViewer from 'src/components/widgets/modal/DocumentViewer';
import LogTimeModal from 'src/components/widgets/modal/LogTimeModal';
import useAuth from 'src/hooks/useAuth';
import useSettings from 'src/hooks/useSettings';
import setTitle from 'src/utils/setTitle';
import time from 'src/utils/time';
import * as Yup from 'yup';
import { editCaseStyles } from './stylesheet';
import AttachmentViewModal from 'src/components/widgets/modal/AttachmentViewModal';
import { ClickAwayListener, InputAdornment } from '@mui/material';
import { logTimeApi } from 'src/api/logTimeApi';
import 'ckeditor5/ckeditor5.css';
import LinkCases from 'src/components/LinkCases';
import DeleteLogTimeModal from './DeleteLogTimeModal';
import { TimelineSection } from './TimeLine';
import type {
  CaseData,
  idNameType,
  Input,
  LogEntry,
  statusesType,
  statusInputValueType,
} from 'src/types/components/cases.type';
import {
  convertSecondsToTimeString,
  convertToSeconds,
} from './utils/converter';
import TimeTracking from './TimeTracking';
import BillingAccountDialog from './BillingAccountDialog';
import DeclineDialog from './DeclineDialog';

import logger from 'src/utils/logger';
import { projectModulesApi } from 'src/api/projectModules';

const useStyles = editCaseStyles;

export const JiraSync = () => null;

interface OptionType {
  title: string;
  year?: number;
}
const top100Films: any = [
  { title: 'The Shawshank Redemption', year: 1994 },
  { title: 'The Godfather', year: 1972 },
  { title: 'The Godfather: Part II', year: 1974 },
  { title: 'The Dark Knight', year: 2008 },
  { title: '12 Angry Men', year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: 'Pulp Fiction', year: 1994 },
];

function EditCases({ isProjectCase }: { isProjectCase?: boolean }) {
  setTitle('CRM | Cases Edit');
  const orgEditComponent = false;
  const { user } = useAuth();
  const { caseID } = useParams();
  const navigate = useNavigate();
  let hideItem = null;
  let returnUrl = '/erp/cases';
  if (orgEditComponent) {
    const { hideItems }: any = useOutletContext();
    hideItem = hideItems || false;
    const location = useLocation();
    const locationSlugs = location.pathname.split('/');
    locationSlugs.pop(); // remove case-id from location
    returnUrl = locationSlugs.join('/');
  }
  const handleReturn = () => {
    navigate(returnUrl);
  };

  const classes = useStyles();

  const [moduleValue, setModuleValue] = useState<any>(null);
  const [moduleList, setModuleList] = useState(top100Films);
  const [moduleEditable, setModuleEditable] = useState<boolean>(false);

  const [billingAccounts, setBillingAccounts] = useState([]);

  const [caseDataOld, setCaseDataOld] = useState<CaseData>(null);
  const [caseData, setCaseData] = useState<CaseData>(null);
  const [isSyncing, setIsSyncing] = useState<boolean>(false);
  const [labelsData, setLabelsData] = useState<string[]>([]);
  const [labelInputValue, setLabelInputValue] = useState<string>('');
  const [labelsOptions, setLabelsOptions] = useState<string[]>([]);
  const [statusInputValue, setStatusInputValue] =
    useState<statusInputValueType>({});
  const [statuses, setStatuses] = useState<statusesType[]>([]);
  const [chkIspApprove, setChkIspApprove] = useState<any>(null);
  const [bugOccur, setBugOccur] = useState<string>('');
  const [bugExpect, setBugExpect] = useState<string>('');
  const [dueDate, setDueDate] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [isStartDateEditable, setIsStartDateEditable] =
    useState<boolean>(false);
  const [isDueDateEditable, setIsDueDateEditable] = useState<boolean>(false);
  const copyButtonRef = useRef(null);
  const copyClientButtonRef = useRef(null);
  const timeoutRef = useRef(null);
  const uploadRef = useRef<any>(null);

  const { settings } = useSettings();
  const [organization, setOrganization] = useState<idNameType>({
    id: '',
    name: '',
  });
  const [project, setProject] = useState<idNameType>({
    id: '',
    name: '',
  });
  const [priorityAllOptions, setPriorityAllOptions] = useState<idNameType[]>(
    []
  );
  const [caseTypeOptions, setCaseTypeOptions] = useState<idNameType[]>([]);
  const [caseType, setCaseType] = useState<idNameType>({});
  const [priority, setPriority] = useState<idNameType>({});
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const toggleIsLoad = () => setIsLoad(!isLoad);
  const [projectSponserId, setProjectSponserId] = useState<idNameType[]>([]);
  const [releaseVersion, setReleaseVersion] = useState<any>([]);
  // const [projectSponserInput, setProjectSponserInput] = useState<any>('');
  const [stakeholderId, setStakeholderId] = useState<idNameType[]>([]);
  const [collaboratorId, setCollaboratorId] = useState<idNameType[]>([]);
  const [severity, setSeverity] = useState<idNameType>(null);
  const [stakeholderInput, setStakeholderInput] = useState<string>('');
  const [collaboratorInput, setCollaboratorInput] = useState<string>('');
  // const [stakeholderValue] = useState<any>([]);
  const [allExternalUsers, setAllExternalUsers] = useState<idNameType[]>([]);
  // logger(allExternalUsers);
  const [escalationManagerId, setEscalationManagerId] = useState<idNameType>(
    {}
  );

  const [escalationManagerInput, setEscalationManagerInput] =
    useState<string>('');
  const [assigneeId, setAssigneeId] = useState<idNameType>({});
  const [allInternalUsers, setAllInternalUsers] = useState<idNameType[]>([]);
  const [allStakeholders, setAllStakeholders] = useState<idNameType[]>([]);
  const [allLogs, setAllLogs] = useState<LogEntry[]>([]);
  const [projectLinks, setProjectLinks] = useState<any>([]);
  const [description, setDescription] = useState<string>('');
  const [tabValue, setTabValue] = useState<number>(1);
  const [languageType, setLanguageType] = useState<string>('en');
  const [allSeverities, setAllSeverities] = useState<idNameType[]>([]);
  const [isImagePopupOpen, setIsImagePopupOpen] = useState<boolean>(false);
  const [logTimeModalOpen, setlogTimeModalOpen] = useState<boolean>(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string>('');
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState<string>('');
  const [isTitleEditMode, setIsTitleEditMode] = useState<boolean>(false);
  const [isBugDescriptionEditable, setIsBugDescriptionEditable] =
    useState<boolean>(false);
  const [isDescriptionEditMode, setIsDescriptionEditMode] =
    useState<boolean>(false);
  const [isPriorityEditMode, setIsPriorityEditMode] = useState<boolean>(false);
  const [isSeverityEditMode, setIsSeverityEditMode] = useState<boolean>(false);
  const [isAssigneeEditMode, setIsAssigneeEditMode] = useState<boolean>(false);
  const [isStakeholderEditMode, setIsStakeholderEditMode] =
    useState<boolean>(false);
  const [isCollaboratorEditMode, setIsCollaboratorEditMode] =
    useState<boolean>(false);
  const [isEscalationManagerEditMode, setIsEscalationManagerEditMode] =
    useState<boolean>(false);
  const [isCaseTypeEditMode, setIsCaseTypeEditMode] = useState<boolean>(false);
  const [isLabelEditable, setIsLabelEditable] = useState<boolean>(false);
  const [isProjectEditable, setIsProjectEditable] = useState<boolean>(false);
  const [isBillingEditable, setIsBillingEditable] = useState<boolean>(false);
  const [isOrganizationEditable, setIsOrganizationEditable] =
    useState<boolean>(false);
  const [isTimeEstimateEditable, setIsTimeEstimateEditable] =
    useState<boolean>(false);
  const [billingAccountType, setBillingAccountType] = useState<any>('');
  const [billingAccountTypeEditable, setBillingAccountTypeEditable] =
    useState<boolean>(false);

  const [allFixVersions, setAllFixVersions] = useState<any>([]);
  const [isFixVersionEditable, setIsFixVersionEditable] =
    useState<boolean>(false);

  const [sprints, setSprints] = useState<any>([]);
  const [currentSprint, setCurrentSprint] = useState<any>({});
  const [isSprintsEditable, setIsSprintsEditable] = useState<boolean>(false);

  const [isDocumentViewerOpen, setIsDocumentViewerOpen] =
    useState<boolean>(false);
  const [billingType, setBillingType] = useState(null);
  const [timeEstimate, setTimeEstimate] = useState('');
  const [loggedTime, setLoggedTime] = useState([]);
  const [totalTime, setTotalTime] = useState(0);
  const [remainingTimePercent, setRemainingTimePercent] = useState(0);
  const [loggedTimePercent, setLoggedTimePercent] = useState(0);
  const [loggedTimeEditData, setLoggedTimeEditData] = useState({});

  const [isDeclineCase, setIsDeclineCase] = useState<boolean>(false);
  const [filePath, setFilePath] = useState<string[]>([]);
  const [inputs, setInputs] = useState<any>([
    { id: 1, value: '', label: '', caseKey: '' }, // Initial empty input
  ]);
  const [allCasesData, setAllCasesData] = useState<any[]>([]);

  const [googleDocLinks, setGoogleDocLinks] = useState<Input[]>([
    { id: Date.now(), value: '', label: '' },
  ]);
  const [figmaLinks, setFigmaLinks] = useState<Input[]>([
    { id: Date.now(), value: '', label: '' },
  ]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedLogTime, setSelectedLogTime] = useState(null);

  const [openAttachmentDeleteDialog, setOpenAttachmentDeleteDialog] =
    useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState(null);

  const [openBillingAccountDialog, setOpenBillingAccountDialog] =
    useState(false);
  const [selectedBillingAccount, setSelectedBillingAccount] = useState(null);

  const [showDeclineDialog, setShowDeclineDialog] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);

  const [debouncedValue, setDebouncedValue] = useState('');

  // Debouncing logic to handle delayed actions
  React.useEffect(() => {
    const handler = setTimeout(() => {
      if (debouncedValue !== '') {
        console.log('This message is displayed after 700 ms.', {
          inputValue: debouncedValue,
        });
      }
    }, 1000);

    return () => clearTimeout(handler);
  }, [debouncedValue]);

  const handleCopy = async () => {
    const caseText = `Case Title: ${caseData?.caseKey} - ${caseData?.summary}\nCase Link: https://apps.it22.nl/erp/cases/${caseData?.caseKey}
    `;
    try {
      await navigator.clipboard.writeText(caseText);

      if (copyButtonRef.current) {
        copyButtonRef.current.innerText = 'Copied!';
        setTimeout(() => {
          copyButtonRef.current.innerText = 'Copy Case for IT22';
        }, 2000); // Reset text after 2 seconds
      }
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const handleCopyForClient = async () => {
    const caseText = `Case Title: ${caseData?.caseKey} - ${caseData?.summary}\nCase Link: https://portal.it22.nl/cases/${caseData?.caseKey}
    `;
    try {
      await navigator.clipboard.writeText(caseText);
      if (copyClientButtonRef.current) {
        copyClientButtonRef.current.innerText = 'Copied!';
        setTimeout(() => {
          copyClientButtonRef.current.innerText = 'Copy Case for Client';
        }, 2000); // Reset text after 2 seconds
      }
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  // Handle button click to clear files by calling the method on the ref
  const handleClearFiles = () => {
    if (uploadRef.current) {
      uploadRef.current.clearFiles();
    }
  };

  useEffect(
    () =>
      // Clean up timeout when the component unmounts
      () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      },
    []
  );

  useEffect(() => {
    // Sum all logged hours in seconds
    let totalLoggedSeconds = loggedTime.reduce(
      (acc, item) => acc + item?.loggedHoursInSeconds,
      0
    );
    // Calculate the percentage of the total logged seconds with respect to the total time
    if (totalLoggedSeconds > totalTime) {
      totalLoggedSeconds = totalTime;
    }
    const progressPercentage = (totalLoggedSeconds / totalTime) * 100;
    const remainingPercent = 100 - progressPercentage;

    // Update the progress state
    setLoggedTimePercent(progressPercentage);
    setRemainingTimePercent(remainingPercent);
  }, [totalTime, loggedTime, remainingTimePercent]);
  const handleDocumentClick = (documentUrl) => {
    setSelectedDocumentUrl(documentUrl);
    setIsDocumentViewerOpen(true);
  };

  const handleCloseDocumentViewer = () => {
    setIsDocumentViewerOpen(false);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImageUrl(imageUrl);
    setIsImagePopupOpen(true);
  };

  const handleCloseImagePopup = () => {
    setIsImagePopupOpen(false);
  };

  const handleLogTimeModalOpen = (state) => {
    setlogTimeModalOpen(state);
    if (state) {
      setLoggedTimeEditData({});
    }
  };

  const handleEditLogTimeModalOpen = (event, item) => {
    setlogTimeModalOpen(true);
    setLoggedTimeEditData(item);
  };

  const handleTabValue = (e: any, newValue: number) => {
    setTabValue(newValue);
  };

  const getAutoCompleteReleaseVersion = async (projectId) => {
    try {
      const res = await casesApi?.getAutoCompleteReleaseVersion(projectId);
      setAllFixVersions(res?.data?.active);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setAllFixVersions([]);
      }
    }
  };

  const getAutoCompleteSprints = async (projectId) => {
    try {
      const res = await casesApi?.getAutoCompleteSprints(projectId);
      setSprints(res?.data?.active);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setSprints([]);
      }
    }
  };

  const addEmptyRow = (links: Input[]): Input[] => [
    ...links,
    { id: Date.now(), value: '', label: '' },
  ];

  const getCaseById = async () => {
    try {
      const response = await casesApi?.getCaseById(caseID);
      if (response.status === 204) {
        navigate('/erp/cases');
      } else {
        const res = response?.data;
        setCaseData(res);
        setCaseDataOld(res);
        setBillingAccounts(res.billingAccount || []);
        setOrganization({
          id: res?.organization?.id,
          name: res?.organization?.name,
        });
        if (res?.caseType?.name === 'Application Bug') {
          setSeverity({ id: res?.severity?.id, name: res?.severity?.name });
        } else {
          setSeverity(res.severity);
        }
        setProject({
          id: res?.project?.id,
          name: res?.project?.name,
        });
        setProjectSponserId(res?.projectSponsor);

        setChkIspApprove(res?.isApproved);
        setReleaseVersion(res?.releaseVersion);
        setStakeholderId(res?.stakeHolder);
        setCollaboratorId(res?.collaborators);
        setAssigneeId(res?.assignee);
        setEscalationManagerId(res?.escalationManager);
        setEscalationManagerInput(res?.escalationManager?.name);
        setPriority(res?.priority);
        setCaseType(res?.caseType);
        setCurrentSprint(res?.sprint);
        setLabelsData(res?.labels);
        setStatusInputValue(res?.status);
        setAllLogs(res?.logs || []);
        setProjectLinks(res?.project?.docUrls);
        setLoggedTime(res?.loggedTime || []);
        setDescription(res?.description || '');
        setBugOccur(
          res?.bugQuestions?.length >= 1
            ? res?.bugQuestions[0]?.description
            : ''
        );
        setBugExpect(
          res?.bugQuestions?.length >= 2
            ? res?.bugQuestions[1]?.description
            : ''
        );
        setBillingType({ id: res?.expense || '', name: res?.expense || '' });
        setDueDate(res?.dueDate);
        setBillingAccountType(res?.billingAccountType);
        setStartDate(res?.startDate);
        setGoogleDocLinks(
          res?.docUrls?.googleDocLinks?.length > 0
            ? addEmptyRow(
                res?.docUrls?.googleDocLinks?.map((link, index) => ({
                  id: index,
                  value: link?.url,
                  label: link?.label,
                }))
              )
            : [{ id: Date.now(), value: '', label: '' }]
        );
        setInputs(
          res?.linkedCases?.length > 0
            ? addEmptyRow(
                res?.linkedCases?.map((link, index) => ({
                  id: link?.id,
                  value: link?.name,
                  label: link?.key,
                  caseKey: link?.caseKey,
                }))
              )
            : [{ id: 1, value: '', label: '', caseKey: '' }]
        );
        setFigmaLinks(
          res?.docUrls?.figmaLinks?.length > 0
            ? addEmptyRow(
                res?.docUrls?.figmaLinks?.map((link, index) => ({
                  id: index,
                  value: link?.url,
                  label: link?.label,
                }))
              )
            : [{ id: Date.now(), value: '', label: '' }]
        );

        const timeString = convertSecondsToTimeString(res?.timeEstimate);
        setTimeEstimate(timeString);
        setTotalTime(res?.timeEstimate);
        await getAutoCompleteReleaseVersion(res?.project?.id);
        await getAutoCompleteSprints(res?.project?.id);
      }
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setCaseData(null);
        setCaseDataOld(null);
        setOrganization({});
        setProject({});
        setProjectSponserId([]);
        setStakeholderId([]);
        setCollaboratorId([]);
        setAssigneeId({});
        setEscalationManagerId({});
        setEscalationManagerInput('');
        setBugOccur('');
        setBugExpect('');
        setPriority({});
        setLabelsData([]);
        setStatusInputValue({});
        setAllLogs([]);
        setSeverity(null);
        setBillingType(null);
      }
    }
  };

  const handleDeleteAttachmentOpenHandler = (item) => {
    setSelectedAttachment(item); // Store the selected item
    setOpenAttachmentDeleteDialog(true); // Open the dialog
  };

  const handleDeleteLogTimeModalOpen = (item) => {
    setSelectedLogTime(item); // Store the selected item
    setOpenDeleteDialog(true); // Open the dialog
  };

  const handleDeleteLogTimeModalClose = () => {
    setOpenDeleteDialog(false); // Close the dialog without action
  };

  const handleDeleteAttachmentModalClose = () => {
    setOpenAttachmentDeleteDialog(false); // Close the dialog without action
  };

  const handleDeleteConfirm = async () => {
    try {
      await logTimeApi?.deleteLogTime(caseData?.id, selectedLogTime?.id);

      toast.success('Time Log delete successfully');
      setOpenDeleteDialog(false); // Close the dialog after deletion
      getCaseById();
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  const handleDeleteAttachmentConfirm = async () => {
    try {
      await casesApi.deleteCaseAttachment(caseData?.id, selectedAttachment);
      toast.success('Attachment Deleted Successfully');
      setOpenAttachmentDeleteDialog(false);
      getCaseById();
    } catch (err) {
      console.error(err?.message ?? 'Something went wrong');
      toast.error(err?.message || 'Something went wrong');
    }
  };

  const getAutoCompleteStatus = async () => {
    try {
      const res = await casesApi?.getStatuses();

      const filteredItems = res?.data.filter((item) => {
        // If chkIspApprove is true, remove "Declined"
        if (chkIspApprove === true && item.name === 'Declined') {
          return false;
        }
        return true; // Keep all other items
      });
      setStatuses(filteredItems);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setStatuses([]);
      }
    }
  };

  const clickAwayHandler = () => {
    setIsDescriptionEditMode(false);
  };

  const getAllExternalUsersAutoComplete = async () => {
    try {
      const res = await casesApi?.getAutoCompleteUser(true);
      setAllExternalUsers(res?.data);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setAllExternalUsers([]);
      }
    }
  };

  const getAllInternalUsersAutoComplete = async () => {
    try {
      const res = await casesApi?.getAutoCompleteUser(false);
      setAllInternalUsers(res?.data);
      setAllStakeholders(res?.data);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setAllInternalUsers([]);
        setAllStakeholders([]);
      }
    }
  };

  const getAllCasesAutocompleteHandler = async (search) => {
    try {
      console.log('getAllCasesAutocompleteHandler', search);
      const res = await casesApi?.getAllCasesAutocomplete(search);
      setAllCasesData(res?.data);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  const getAutoCompletePriority = async () => {
    try {
      const res = await casesApi?.getPriorities();
      setPriorityAllOptions(res?.data);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setPriorityAllOptions([]);
      }
    }
  };

  const getAllSeverities = async () => {
    try {
      const response = await casesApi.getAutoCompleteSeverity();
      setAllSeverities(response?.data);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setAllSeverities([]);
      }
    }
  };

  const getCaseType = async () => {
    try {
      const response = await casesApi.getCaseTypes();
      setCaseTypeOptions(response?.data);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setCaseTypeOptions([]);
      }
    }
  };

  const escalateById = async () => {
    try {
      const response = await casesApi?.escalateById(caseData?.id);
      if (response?.status === 201) {
        setCaseData(response?.data);
        getCaseById();
      }
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setCaseData(null);
      }
    }
  };

  const syncJiraByCaseId = async () => {
    try {
      setIsSyncing(true);
      const res = await casesApi?.syncJiraByCaseId(caseData?.id);
      if (res?.status === 200) {
        toast.success('successfully Synced');
        getCaseById();
      }
      setIsSyncing(false);
    } catch (error) {
      setIsSyncing(false);
      const errorMessage = error?.response?.data?.message;
      if (error?.response?.status !== 401) {
        toast.error(errorMessage);
      }
    }
  };

  const updateIndividual = async (columnName: any, values: any) => {
    try {
      const payload = {
        [columnName]: values,
      };
      console.log('updateIndividual', payload);
      const caseId = caseData?.id;
      const response = await casesApi?.updateCase(caseId, payload);
      if (response?.status === 200) {
        toast.success('Case Successfully Updated');
        getCaseById();
      }
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  const priorityColors = {
    highest: '#FF0000', // Red
    blocker: '#FF4500', // Orange Red
    high: '#F16063', // High (as specified)
    medium: '#FFA500', // Orange
    minor: '#FFD700', // Gold
    low: '#9ACD32', // Yellow Green
    lowest: '#00FF00', // Lime
    backLog: '#808080', // Gray
  };

  const getColor = (priorityName: any) =>
    priorityColors[priorityName.toLowerCase()] || '#000000';

  const BreadCrumbsData = {
    title: '',
    links: [
      {
        name: 'cases',
        to: '/erp/cases',
      },
      {
        name: `${caseData?.caseKey}`,
        to: `/erp/cases/${caseID}`,
        color: `${caseData?.issueType?.name === 'Bug' ? 'red' : '#4baee8'}`,
        copyDetails: {
          id: caseData?.caseKey,
          title: caseData?.summary,
        },
        allowCopy: true,
      },
      {
        name: `${caseData?.caseType?.name}`,
        to: `/erp/cases/${caseID}`,
      },
    ],
  };

  const BreadCrumbCaseProj = {
    title: '',
    links: [
      {
        name: 'cases',
        to: `${hideItem?.link}`,
      },
      {
        name: `${caseData?.caseKey}`,
        to: `/erp/cases/${caseID}`,
        color: 'red',
      },
    ],
  };

  const hasMultipleNullValues = (obj: any) => {
    let nullCount = 0;

    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key) && obj[key] === null) {
        nullCount++;
        if (nullCount > 1) {
          return true; // Found multiple null values
        }
      }
    }

    return false; // No or only one null value found
  };

  const hasMultipleNulls = hasMultipleNullValues(assigneeId);
  const getLabels = async () => {
    try {
      const res = await casesApi?.getAutoCompleteLabels();
      const uniqueArray = res?.data?.filter(
        (value, index, self) => self.indexOf(value) === index
      );
      setLabelsOptions(uniqueArray);
    } catch (error) {
      if (error?.response?.status !== 401) {
        setLabelsOptions([]);
        toast.error(error?.response?.data?.message);
      }
    }
  };

  const showTranslation = async (
    textData: string,
    lang?: string,
    field?: string,
    id?: string
  ) => {
    const payload = {
      text: textData,
      target_lang: lang,
    };

    try {
      const res = await translationApi?.translateText(payload);
      const detectedLanguage =
        res?.data?.data?.translations[0].detectedSourceLanguage;
      const translatedText = res?.data?.data?.translations[0].translatedText;
      const updatedComments = caseData.comment.map((comment) => {
        if (comment.id === id) {
          return { ...comment, description: translatedText };
        }
        return comment;
      });
      const updatedLogs = caseData.logs.map((log) => {
        if (log.id === id) {
          return { ...log, change: translatedText };
        }
        return log;
      });
      // Define a conditional object to specify how to update the state based on the field
      const fieldActions = {
        caseSummary: () => {
          setCaseData({
            ...caseData,
            summary: translatedText,
          });
        },
        caseCommentData: () => {
          setCaseData({
            ...caseData,
            comment: updatedComments,
          });
        },
        caseLogData: () => {
          setCaseData({
            ...caseData,
            logs: updatedLogs,
          });
        },
        caseDescription: () => {
          setDescription(translatedText);
        },
        // Add more fields and actions as needed
      };

      // Call the appropriate action based on the field
      if (field && fieldActions[field]) {
        fieldActions[field]();
      }

      setLanguageType(detectedLanguage);
    } catch (error) {
      if (error?.response?.status !== 401) {
        setCaseData(null);
        toast.error(error?.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    getAutoCompletePriority();
    getCaseType();
    getLabels();
    getAllSeverities();
    const timeout = setTimeout(() => {
      getAllExternalUsersAutoComplete();
      getAllInternalUsersAutoComplete();
    }, 800);

    if (
      !user?.permissions?.includes('case-get-by-id') &&
      !user?.permissions?.includes('case-update') &&
      !user?.permissions?.includes('case-timeline-activity-get-all') &&
      !user?.permissions?.includes('case-comment-get-by-id') &&
      !user?.permissions?.includes('case-comment-update') &&
      !user?.permissions?.includes('case-comment-create') &&
      !user?.permissions?.includes('case-comment-delete') &&
      !user?.permissions?.includes('case-comment-get-all') &&
      !user?.permissions?.includes('case-escalate-read') &&
      !user?.permissions?.includes('case-jira-sync-read') &&
      !user?.permissions?.includes('case-status-update')
    ) {
      window.location.href = '/admin/not-found';
    }

    return () => {
      clearTimeout(timeout);
      setAllInternalUsers([]);
      setAllStakeholders([]);
    };
  }, []);

  useEffect(() => {
    getCaseById();
  }, [isLoad]);

  const filterEmptyLinks = (links: Input[]) =>
    links?.filter(
      (link) => link?.value?.trim() !== '' || link?.label?.trim() !== ''
    );

  const getAllModules = async () => {
    try {
      if (organization.id && project.id) {
        const response = await projectModulesApi.getModulesByOrgAndProject(
          organization.id,
          project.id
        );
        const moduleNames = response?.data?.map((module) => module.name);
        setModuleList(moduleNames);
      }
    } catch (error) {
      logger(error, 'error');
      setAllSeverities([]);
    }
  };

  useEffect(() => {
    getAllModules();
  }, [organization?.id, project?.id]); // Added organization and project dependencies

  const handleStartDateChange = (event) => {
    const newStartDate = event.target.value;

    // Check if due date exists and new start date is after due date
    if (dueDate && newStartDate > dueDate) {
      toast.error('Start date cannot be after due date');
      return;
    }

    setStartDate(newStartDate);
    updateIndividual('startDate', newStartDate);
  };

  const handleDueDateChange = (event) => {
    const newDueDate = event.target.value;

    // Check if start date exists and new due date is before start date
    if (startDate && newDueDate < startDate) {
      toast.error('Due date cannot be before start date');
      return;
    }

    setDueDate(newDueDate);
    updateIndividual('dueDate', newDueDate);
  };

  const handleAddGoogleDocLinks = () => {
    const payload = [
      ...googleDocLinks,
      { id: Date.now(), value: '', label: '' },
    ];
    setGoogleDocLinks([
      ...googleDocLinks,
      { id: Date.now(), value: '', label: '' },
    ]);
    const docUrls = {
      googleDocLinks: filterEmptyLinks(payload).map((link) => ({
        url: link?.value,
        label: link?.label,
      })),
      figmaLinks: filterEmptyLinks(figmaLinks).map((link) => ({
        url: link?.value,
        label: link?.label,
      })),
    };
    updateIndividual('docUrls', docUrls);
  };

  const handleAddFigmaLinks = () => {
    const payload = [...figmaLinks, { id: Date.now(), value: '', label: '' }];
    setFigmaLinks([...figmaLinks, { id: Date.now(), value: '', label: '' }]);

    const docUrls = {
      googleDocLinks: filterEmptyLinks(googleDocLinks).map((link) => ({
        url: link?.value,
        label: link?.label,
      })),
      figmaLinks: filterEmptyLinks(payload).map((link) => ({
        url: link?.value,
        label: link?.label,
      })),
    };
    updateIndividual('docUrls', docUrls);
  };

  const handleRemoveGoogleDocLinks = (id) => {
    const payload = googleDocLinks?.filter((input) => input.id !== id);
    setGoogleDocLinks(googleDocLinks?.filter((input) => input.id !== id));
    const docUrls = {
      googleDocLinks: filterEmptyLinks(payload).map((link) => ({
        url: link?.value,
        label: link?.label,
      })),
      figmaLinks: filterEmptyLinks(figmaLinks).map((link) => ({
        url: link?.value,
        label: link?.label,
      })),
    };
    updateIndividual('docUrls', docUrls);
  };

  const handleRemoveFigmaLinks = (id) => {
    const payload = figmaLinks?.filter((input) => input.id !== id);
    setFigmaLinks(figmaLinks?.filter((input) => input.id !== id));

    const docUrls = {
      googleDocLinks: filterEmptyLinks(googleDocLinks).map((link) => ({
        url: link?.value,
        label: link?.label,
      })),
      figmaLinks: filterEmptyLinks(payload).map((link) => ({
        url: link?.value,
        label: link?.label,
      })),
    };
    updateIndividual('docUrls', docUrls);
  };

  useEffect(() => {
    if (window.location.href.includes('declined-cases')) {
      setIsDeclineCase(true);
    }
    getAllCasesAutocompleteHandler('');
  }, []);

  useEffect(() => {
    if (chkIspApprove != null) {
      getAutoCompleteStatus();
    }
  }, [chkIspApprove]);

  // Link Cases Section
  const labelOptions = [
    { id: 1, name: 'Is Blocked By', value: 'is_blocked_by' },
    { id: 1, name: 'Blocks', value: 'blocks' },
    { id: 2, name: 'Is Duplicated By', value: 'is_duplicated_by' },
    { id: 2, name: 'Duplicates', value: 'duplicates' },
    { id: 2, name: 'Identify In', value: 'identify_in' },
    { id: 2, name: 'Is Cause By', value: 'is_cause_by' },
    { id: 2, name: 'Is Add-On To', value: 'is_addon_to' },
  ];

  const handleAddInput = () => {
    const newInput = { id: Date.now(), value: '', label: '', caseKey: '' };
    const payload = [...inputs, newInput];

    // Update state with the new input
    setInputs(payload);

    // Filter out inputs where any field is empty
    const linkedCases = payload
      .filter(
        (link) => link.value !== '' && link.label !== '' && link.caseKey !== ''
      )
      .map((link) => ({
        id: link.id,
        key: link.label,
        name: link.value,
        caseKey: link.caseKey,
      }));

    // Update the individual only if there are valid linkedCases
    updateIndividual(
      'linkedCases',
      linkedCases.length > 0 ? linkedCases : null
    );
  };

  const handleRemoveInput = (id: number) => {
    const payload = inputs?.filter((input) => input.id !== id);
    const filteredData = filterEmptyLinks(payload).map((link: any) => ({
      id: link.id,
      key: link.label,
      name: link.value,
      caseKey: link.caseKey,
    }));
    updateIndividual(
      'linkedCases',
      filteredData.length > 0 ? filteredData : null
    );
    setInputs(filteredData);
  };

  const handleInputChange = (id: number, newValue: any) => {
    setInputs((prevInputs) =>
      prevInputs.map((input) =>
        input.id === id
          ? {
              ...input,
              value: newValue?.summary || '',
              id: newValue?.id || '',
              caseKey: newValue?.caseKey || '',
              update: 'true',
            }
          : input
      )
    );
    // setTimeout(() => onAdd(), 2000);
    console.log('newValue', newValue);
    getAllCasesAutocompleteHandler(newValue);
  };

  const handleLabelChange = (id: number, newValue: any) => {
    setInputs((prevInputs) =>
      prevInputs.map((input) =>
        input.id === id ? { ...input, label: newValue?.name || '' } : input
      )
    );
  };

  function uploadAdapter(loader) {
    return {
      upload: () =>
        new Promise((resolve) => {
          loader.file.then(async (file) => {
            const formData = new FormData();
            formData.append('file', file);
            const image = await userApi.uploadAttachments(formData);
            resolve({
              default: `${image?.data?.blob_url}`,
            });
          });
        }),
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
      uploadAdapter(loader);
  }

  useEffect(() => {
    if (caseData?.status?.name === 'Declined') {
      navigate(`/erp/cases/declined-cases/${caseData?.caseKey}`);
      setIsDeclineCase(true);
    }
  }, [caseData]);

  const editorConfig = {
    toolbar: {
      items: [
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        '|',
        'link',
        'blockQuote',
        'insertImage',
        '|',
        'bulletedList',
        'numberedList',
      ],
      shouldNotGroupWhenFull: false,
    },
    plugins: [
      AutoImage,
      BlockQuote,
      Bold,
      Essentials,
      Heading,
      ImageBlock,
      ImageCaption,
      ImageInline,
      ImageResize,
      ImageStyle,
      ImageTextAlternative,
      ImageToolbar,
      ImageUpload,
      Indent,
      IndentBlock,
      Italic,
      Link,
      List,
      ListProperties,
      Paragraph,
      SimpleUploadAdapter,
      TextTransformation,
    ],
    blockToolbar: [
      'bold',
      'italic',
      '|',
      'link',
      '|',
      'bulletedList',
      'numberedList',
      'outdent',
      'indent',
    ],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph',
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Heading 1',
          class: 'ck-heading_heading1',
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2',
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Heading 3',
          class: 'ck-heading_heading3',
        },
      ],
    },
    image: {
      toolbar: [
        'toggleImageCaption',
        'imageTextAlternative',
        '|',
        'imageStyle:inline',
        'imageStyle:wrapText',
        'imageStyle:breakText',
        '|',
        'resizeImage',
      ],
    },
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file',
          },
        },
      },
    },
    list: {
      properties: {
        styles: true,
        startIndex: true,
        reversed: true,
      },
    },
    extraPlugins: [uploadPlugin],
    placeholder: 'Enter your description here',
  };

  const handleBillingAccountChange = (newValue: any) => {
    setSelectedBillingAccount(newValue);
    if (caseData?.loggedTime?.length > 0 && caseData?.billingAccountType) {
      setOpenBillingAccountDialog(true);
    } else {
      setBillingAccountType(newValue?._id);
      updateIndividual('billingAccountType', {
        ...newValue,
        id: newValue?._id,
        shiftWorkLogsToThis: false,
      });
      setBillingAccountTypeEditable(false);
    }
  };

  const handleBillingAccountConfirm = (shiftWorkLogs: boolean) => {
    if (selectedBillingAccount) {
      setBillingAccountType(selectedBillingAccount?._id);
      updateIndividual('billingAccountType', {
        ...selectedBillingAccount,
        id: selectedBillingAccount?._id,
        shiftWorkLogsToThis: shiftWorkLogs,
      });
      setBillingAccountTypeEditable(false);
    }
    setOpenBillingAccountDialog(false);
  };

  // Add this state near other similar state declarations
  const [isEnvironmentEditable, setIsEnvironmentEditable] = useState(false);

  return (
    <>
      {
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
          }}
          className={`${classes.box}`}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            marginBottom="10px"
            sx={{ backgroundColor: 'white', padding: '10px 15px !important' }}
            className="caseDetailsHeader">
            <Typography
              fontSize="14px"
              fontWeight="700">{`${caseData?.caseKey} - ${caseData?.summary}`}</Typography>
            <Box
              className="caseDetailsBtns"
              sx={{
                display: 'flex',
                gap: '10px',
                justifyContent: 'end',
                flexWrap: 'wrap',
              }}>
              <Button
                ref={copyClientButtonRef}
                variant="contained"
                color="secondary"
                sx={{
                  padding: '4px 8px',
                  fontSize: '12px',
                  minWidth: '151px',
                }}
                onClick={handleCopyForClient}>
                Copy Case for Client
              </Button>
              <Button
                ref={copyButtonRef}
                variant="contained"
                color="secondary"
                sx={{
                  padding: '4px 8px',
                  fontSize: '12px',
                  minWidth: '151px',
                }}
                onClick={handleCopy}>
                Copy Case for IT22
              </Button>
            </Box>
          </Box>
          <Container
            maxWidth={settings.compact ? 'xl' : false}
            className={`${hideItem?.customClass ? 'orgEditCase' : ''}`}
            sx={{ padding: isProjectCase ? '0px !important' : '0px 16px' }}>
            <Formik
              enableReinitialize
              initialValues={{
                summary: caseData?.summary,
                description: caseData?.description,
                sponsorId: projectSponserId,
                stakeHolderId: stakeholderId,
                escalationManagerId: escalationManagerInput,
                assigneeID: assigneeId,
                orgId: organization,
                projectId: project,
                caseOwner: caseData?.createdBy?.name,
                severity,
                bugOccur,
                bugExpect,
                priority,
                caseType: caseData?.caseType, // added for conditional yup validation when caseType is a bug
                labels: [],
                issueType: { id: '', name: '' },
                statusId: { id: '', name: '' },
                collaborators: collaboratorId,
              }}
              onSubmit={async (values) => {
                try {
                  const payload: any = {};
                  if (caseDataOld?.summary !== values?.summary) {
                    payload.summary = values?.summary;
                  }
                  if (caseData?.description !== description) {
                    payload.description = description;
                  }
                  if (filePath?.length) {
                    payload.attachmentId = [
                      ...caseData?.attachmentId,
                      ...filePath,
                    ];
                  }

                  if (caseDataOld?.caseType?.name === 'Application Bug') {
                    payload.bugQuestions = [
                      {
                        questionKey:
                          caseData?.bugQuestions?.length >= 1
                            ? caseData?.bugQuestions[0]?.questionKey
                            : '',
                        description: values?.bugOccur,
                      },
                      {
                        questionKey:
                          caseData?.bugQuestions?.length >= 2
                            ? caseData?.bugQuestions[1]?.questionKey
                            : '',
                        description: values?.bugExpect,
                      },
                    ];
                  }
                  // const updatedGoogleDocLinks = filterEmptyLinks(
                  //   googleDocLinks
                  // ).map((link) => ({ url: link?.value, label: link?.label }));
                  // const updatedFigmaLinks = filterEmptyLinks(figmaLinks).map(
                  //   (link) => ({
                  //     url: link?.value,
                  //     label: link?.label,
                  //   })
                  // );

                  // if (
                  //   !_.isEqual(updatedGoogleDocLinks, caseData?.docUrls?.googleDocLinks) ||
                  //   !_.isEqual(updatedFigmaLinks, caseData?.docUrls?.figmaLinks) {
                  //   payload.docUrls = {
                  //     googleDocLinks: updatedGoogleDocLinks,
                  //     figmaLinks: updatedFigmaLinks,
                  //   };
                  // }
                  const caseId = caseData?.id;
                  const response = await casesApi?.updateCase(caseId, payload);
                  if (response?.status === 200) {
                    toast.success('Case Successfully Updated');
                    getCaseById();
                    setFilePath([]);
                    handleClearFiles();
                  }
                } catch (error) {
                  if (error?.response?.status !== 401) {
                    toast.error(error?.response?.data?.message);
                  }
                }
              }}
              validationSchema={Yup.object({
                summary: Yup.string()
                  .trim()
                  .required('Title required')
                  .max(256, 'Maximum 256 characters allowed'),
                // description: Yup.string()
                //   .trim()
                //   .required('Description required'),
                bugOccur: Yup.string().when('caseType.id', {
                  is: (value) => value === '65005f2c0f96e012c1a9b1eb',
                  then: Yup.string()
                    .trim()
                    .required('Answer required')
                    .max(1000, 'Maximum 1000 characters allowed'),
                  otherwise: Yup.string(),
                }),
                bugExpect: Yup.string().when('caseType.id', {
                  is: (value) => value === '65005f2c0f96e012c1a9b1eb',
                  then: Yup.string()
                    .trim()
                    .required('Answer required')
                    .max(1000, 'Maximum 1000 characters allowed'),
                  otherwise: Yup.string(),
                }),
              })}>
              {({
                values,
                errors,
                touched,
                handleSubmit,
                handleChange,
                setFieldValue,
                setFieldTouched,
                setFieldError,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid
                    container
                    gap={4}
                    sx={{ flexWrap: 'nowrap', marginTop: '8px' }}>
                    {/** Left Side Bar */}
                    <Grid
                      item
                      xs={8}
                      sx={{
                        flexDirection: 'column',
                        gap: 4,
                      }}>
                      <Box className="boxSub">
                        <Grid container>
                          <Grid item xs={6}>
                            {hideItem?.heading !== false ? (
                              <Grid
                                container
                                justifyContent="space-between"
                                // spacing={3}
                                mb={1}>
                                <Grid item md={12}>
                                  <SimpleBreadCrumb data={BreadCrumbsData} />
                                </Grid>
                              </Grid>
                            ) : (
                              <div style={{ marginTop: '-20px' }}>
                                <SimpleBreadCrumb data={BreadCrumbCaseProj} />
                              </div>
                            )}
                          </Grid>
                          <Grid
                            xs={6}
                            className={`${classes.box} ${
                              isDeclineCase ? classes.pointerEvent : ''
                            }`}>
                            <Box
                              flexDirection="row"
                              alignItems="flex-start"
                              sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                              }}
                              // marginBottom="10px"
                            >
                              <FormControl sx={{ width: 'auto !important' }}>
                                <Select
                                  sx={{
                                    boxShadow: 'none',

                                    '.MuiOutlinedInput-notchedOutline': {
                                      border: 0,
                                    },
                                  }}
                                  // IconComponent={() => null}
                                  id="priorities"
                                  className={classes.select}
                                  disabled={
                                    !user?.permissions?.includes(
                                      'case-status-update'
                                    )
                                  }
                                  value={
                                    Object.keys(statusInputValue).length !==
                                      0 && statusInputValue?.id
                                  }
                                  onClick={(e) => {
                                    if (
                                      user?.permissions?.includes(
                                        'case-status-update'
                                      ) &&
                                      e
                                    ) {
                                      const getTarget: any = e.target;
                                      const dataName =
                                        getTarget?.getAttribute('data-name');
                                      const dataValue =
                                        getTarget?.getAttribute('data-value');

                                      if (dataName === 'Declined') {
                                        setShowDeclineDialog(true);
                                        setPendingStatusChange({
                                          name: dataName,
                                          id: dataValue,
                                        });
                                      } else if (dataValue !== null) {
                                        setFieldValue('statusId', {
                                          id: dataValue,
                                        });
                                        updateIndividual('status', {
                                          ...statusInputValue,
                                          name: dataName,
                                          id: dataValue,
                                        });
                                      }
                                    }
                                  }}
                                  size="small">
                                  {statuses?.map((opt) => (
                                    <MenuItem
                                      value={opt?.id}
                                      data-name={opt?.name}
                                      sx={{ fontSize: '12px !important' }}>
                                      {opt?.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>
                          </Grid>
                          <Grid xs={12}>
                            <>
                              <Grid
                                container
                                className={`${classes.box} ${
                                  isDeclineCase ? classes.pointerEvent : ''
                                }`}
                                sx={{
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                }}>
                                <Typography
                                  variant="body1"
                                  fontSize="14px"
                                  fontWeight={600}
                                  sx={{
                                    margin: '0px !important',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    setIsTitleEditMode(true);
                                    setFieldTouched('summary', false); // Reset the touched state
                                    setFieldError('summary', ''); // Clear the error state
                                  }}>{`${`Title`}`}</Typography>
                                <Grid container sx={{ width: 'auto', gap: 2 }}>
                                  {isTitleEditMode && (
                                    <Grid>
                                      {values?.summary?.length}
                                      /256
                                    </Grid>
                                  )}
                                </Grid>
                              </Grid>
                              {isTitleEditMode && (
                                <TextField
                                  type="text"
                                  fullWidth
                                  name="summary"
                                  onChange={handleChange}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      handleSubmit();
                                    }
                                  }}
                                  onBlur={() => {
                                    setIsTitleEditMode(false);
                                  }}
                                  value={values?.summary}
                                  error={Boolean(
                                    touched?.summary && errors?.summary
                                  )}
                                  helperText={
                                    touched?.summary && errors?.summary
                                  }
                                  inputProps={{
                                    maxLength: 256,
                                  }}
                                />
                              )}
                            </>
                            {!isTitleEditMode && (
                              <Box
                                className={`${classes.box} ${
                                  isDeclineCase ? classes.pointerEvent : ''
                                }`}
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: '700',
                                  margin: 0,
                                  padding: 0,
                                }}
                                onClick={() => {
                                  setIsTitleEditMode(true);
                                }}>
                                {values?.summary}
                              </Box>
                            )}
                          </Grid>
                          <Grid
                            className={`${classes.box} ${
                              isDeclineCase ? classes.pointerEvent : ''
                            }`}
                            item
                            xs={12}
                            sx={{ marginTop: 0 }}>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                              }}>
                              <Typography
                                variant="body1"
                                fontSize="14px"
                                fontWeight={600}
                                sx={{
                                  margin: '0px !important',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  setIsDescriptionEditMode(true);
                                }}>
                                {' '}
                                {`${`Description`}`}
                              </Typography>
                              {/* <div className={classes.transalationBtn}>
                                <Tooltip title="Translate">
                                  <TranslateIcon
                                    sx={{ height: 18 }}
                                    onClick={() => {
                                      showTranslation(
                                        description,
                                        languageType,
                                        'caseDescription'
                                      );
                                    }}
                                  />
                                </Tooltip>
                              </div> */}
                            </div>
                            <div
                              data-color-mode="light"
                              className="editorMarkup">
                              {isDescriptionEditMode ? (
                                <>
                                  <ClickAwayListener
                                    onClickAway={clickAwayHandler}>
                                    <Box
                                      sx={{
                                        position: 'relative',
                                        maxHeight: '400px',
                                        overflow: 'auto',
                                      }}>
                                      <CKEditor
                                        editor={ClassicEditor}
                                        data={description}
                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setDescription(data);
                                        }}
                                        config={editorConfig as any}
                                      />
                                    </Box>
                                  </ClickAwayListener>
                                </>
                              ) : (
                                <Box
                                  style={{
                                    cursor: 'pointer',
                                    marginTop: 5,
                                    marginBottom: 4,
                                    maxHeight: '300px',
                                    overflow: 'auto',
                                  }}
                                  onClick={() =>
                                    setIsDescriptionEditMode(true)
                                  }>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: description,
                                    }}
                                  />
                                </Box>
                              )}
                              {!isDeclineCase && (
                                <Box mt={1}>
                                  <FileUploadDragDrop
                                    setFilePath={setFilePath}
                                    filePath={filePath}
                                    ref={uploadRef} // Attach the ref to the FileUploadDragDrop component
                                  />
                                </Box>
                              )}
                              {isBugDescriptionEditable ? (
                                <>
                                  {caseData?.caseType?.name ===
                                    'Application Bug' && (
                                    <>
                                      <Box marginTop="16px">
                                        <label htmlFor="label">
                                          {caseData?.bugQuestions?.length >= 1
                                            ? caseData?.bugQuestions[0]
                                                ?.questionKey
                                            : 'N/A'}
                                        </label>
                                        <TextField
                                          type="text"
                                          fullWidth
                                          name="bugOccur"
                                          size="small"
                                          multiline
                                          rows={4}
                                          onChange={handleChange}
                                          onBlur={() => {
                                            setIsBugDescriptionEditable(false);
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                              setIsBugDescriptionEditable(
                                                false
                                              );
                                            }
                                          }}
                                          value={values?.bugOccur}
                                          error={Boolean(
                                            touched?.bugOccur &&
                                              errors?.bugOccur
                                          )}
                                          helperText={
                                            touched?.bugOccur &&
                                            errors?.bugOccur
                                          }
                                        />
                                      </Box>
                                      <Box marginTop="16px">
                                        <label htmlFor="label">
                                          {caseData?.bugQuestions?.length >= 2
                                            ? caseData?.bugQuestions[1]
                                                ?.questionKey
                                            : 'N/A'}
                                        </label>
                                        <TextField
                                          type="text"
                                          fullWidth
                                          name="bugExpect"
                                          size="small"
                                          multiline
                                          rows={4}
                                          onChange={handleChange}
                                          onBlur={() => {
                                            setIsBugDescriptionEditable(false);
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                              setIsBugDescriptionEditable(
                                                false
                                              );
                                            }
                                          }}
                                          value={values?.bugExpect}
                                          error={Boolean(
                                            touched?.bugExpect &&
                                              errors?.bugExpect
                                          )}
                                          helperText={
                                            touched?.bugExpect &&
                                            errors?.bugExpect
                                          }
                                        />
                                      </Box>
                                    </>
                                  )}
                                </>
                              ) : (
                                <div>
                                  {caseData?.caseType?.name ===
                                    'Application Bug' && (
                                    <Box
                                      style={{ cursor: 'pointer' }}
                                      display="flex"
                                      flexDirection="column"
                                      gap="10px"
                                      onClick={() => {
                                        setIsBugDescriptionEditable(true);
                                      }}>
                                      <label
                                        style={{ cursor: 'pointer' }}
                                        htmlFor="label">
                                        {caseData?.bugQuestions?.length >= 1
                                          ? caseData?.bugQuestions[0]
                                              ?.questionKey
                                          : 'N/A'}
                                      </label>
                                      <>{values?.bugOccur}</>
                                      <label
                                        style={{ cursor: 'pointer' }}
                                        htmlFor="label">
                                        {caseData?.bugQuestions?.length >= 2
                                          ? caseData?.bugQuestions[1]
                                              ?.questionKey
                                          : 'N/A'}
                                      </label>
                                      <>{values?.bugExpect}</>
                                    </Box>
                                  )}
                                </div>
                              )}
                              {caseData?.attachmentId?.length > 0 && (
                                <div className="attachmentsDiv">
                                  <Typography
                                    gutterBottom
                                    variant="body1"
                                    fontSize="14px"
                                    fontWeight={600}>
                                    Attachments
                                  </Typography>

                                  {caseData?.attachmentId?.length > 0 && (
                                    <div className="editCommentFileParent">
                                      {caseData?.attachmentId?.map(
                                        (item: any) => {
                                          // const splittedUrl = item?.split('?');
                                          // splittedUrl[1] =
                                          //   'sp=racwdl&st=2024-02-27T13:21:58Z&se=2030-07-29T21:21:58Z&spr=https&sv=2022-11-02&sr=c&sig=YXOHT7%2Bx8VW3RDdgzehtPZLWJ6zHJz%2Bp3QtnduafL4o%3D';
                                          // item = splittedUrl?.join('?');
                                          const getFileType = (items) => {
                                            if (items.includes('.pdf')) {
                                              return 'PDF';
                                            }
                                            if (items.includes('.doc')) {
                                              return 'DOC';
                                            }
                                            if (items.includes('.docx')) {
                                              return 'DOCX';
                                            }
                                            if (items.includes('.txt')) {
                                              return 'TXT';
                                            }
                                            if (items.includes('.xls')) {
                                              return 'XLS';
                                            }
                                            if (items.includes('.xlsx')) {
                                              return 'XLSX';
                                            }
                                            if (items.includes('.csv')) {
                                              return 'CSV';
                                            }
                                            if (items.includes('.tsv')) {
                                              return 'TSV';
                                            }
                                            return null;
                                          };
                                          const fileType = getFileType(item);
                                          if (
                                            item?.includes('.pdf') ||
                                            item?.includes('.doc') ||
                                            item?.includes('.docx') ||
                                            item?.includes('.xls') ||
                                            item?.includes('.xlsx') ||
                                            item?.includes('.csv') ||
                                            item?.includes('.tsv') ||
                                            item?.includes('.txt')
                                          ) {
                                            return (
                                              <>
                                                <a
                                                  role="presentation"
                                                  onClick={() =>
                                                    handleDocumentClick(item)
                                                  }>
                                                  {' '}
                                                  <span>{fileType}</span>
                                                  <InsertDriveFileIcon
                                                    sx={{ fontSize: '60px' }}
                                                  />
                                                  <CancelIcon
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleDeleteAttachmentOpenHandler(
                                                        item
                                                      );
                                                    }}
                                                    className="editCommentFileEdit"
                                                  />
                                                </a>
                                              </>
                                            );
                                          }
                                          const imageFormats = [
                                            '.jpg',
                                            '.jpeg',
                                            '.png',
                                            '.gif',
                                            '.bmp',
                                            '.tiff',
                                            '.webp',
                                            '.svg',
                                            '.ico',
                                          ];
                                          if (
                                            imageFormats.some((extension) =>
                                              item?.includes(extension)
                                            )
                                          ) {
                                            return (
                                              <>
                                                <a>
                                                  <img
                                                    role="presentation"
                                                    src={item}
                                                    alt="img"
                                                    onClick={() =>
                                                      handleImageClick(item)
                                                    }
                                                  />
                                                  <CancelIcon
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleDeleteAttachmentOpenHandler(
                                                        item
                                                      );
                                                    }}
                                                    className="editCommentFileEdit"
                                                  />
                                                </a>
                                              </>
                                            );
                                          }
                                          return null;
                                        }
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}

                              {!isDeclineCase && (
                                <div
                                  style={{
                                    marginTop: '5px',
                                    display: 'flex',
                                    gap: 16,
                                  }}>
                                  {user?.permissions?.includes(
                                    'case-update'
                                  ) && (
                                    <CustomButton
                                      value="update"
                                      onClick={handleSubmit}
                                      color="secondary"
                                      customClass={classes.caseUpdateButton}
                                    />
                                  )}
                                  <CustomButton
                                    value="cancel"
                                    onClick={handleReturn}
                                    customClass={classes.caseUpdateButton}
                                  />
                                </div>
                              )}
                            </div>
                            <Card
                              style={{
                                marginTop: '16px',
                                padding: '0px 10px 10px 10px',
                                boxShadow: '0px 0px 1px 1px #0C1A4B3D',
                                borderRadius: '16px',
                              }}>
                              <Tabs
                                value={tabValue}
                                onChange={handleTabValue}
                                sx={{
                                  '& .MuiButtonBase-root': {
                                    padding: '0px 10px !important',
                                    height: '30px !important',
                                    minHeight: '30px !important',
                                  },
                                  '& .MuiTabs-scroller': {
                                    height: '30px !important',
                                    minHeight: '30px !important',
                                  },
                                  "& .Mui-selected[aria-selected='true']": {
                                    background: '#FFF  !important',
                                    color: '#231F20 !important',
                                    border: '1px solid transparent !important',
                                    borderBottom:
                                      '4px solid #c22027 !important',
                                    position: 'relative',
                                    top: 1,
                                  },
                                  height: '30px',
                                  minHeight: '30px',
                                }}
                                style={{
                                  borderBottom: '1px solid #D9D9D9  !important',
                                }}
                                TabIndicatorProps={{
                                  style: {
                                    backgroundColor: '#c22027',
                                  },
                                }}>
                                <Tab value={1} label="TimeLine" />
                                <Tab value={3} label="WorkLogs" />
                                <Tab value={4} label="Project Documents" />
                              </Tabs>
                              <div>
                                {tabValue === 1 && (
                                  <TimelineSection
                                    data={allLogs}
                                    caseData={caseData}
                                    toggleIsLoad={toggleIsLoad}
                                    user={user}
                                    languageType={languageType}
                                    showTranslation={showTranslation}
                                    handleDocumentClick={handleDocumentClick}
                                    handleImageClick={handleImageClick}
                                  />
                                )}

                                {tabValue === 3 && (
                                  <Box>
                                    {loggedTime.length > 0 ? (
                                      loggedTime.map((item) => (
                                        <Box key={item?.id}>
                                          {' '}
                                          {/* Added key to avoid React warnings */}
                                          <Box
                                            display="flex"
                                            flexDirection="row"
                                            justifyContent="space-between"
                                            padding="0px 8px"
                                            marginTop="-5px">
                                            <Box
                                              display="flex"
                                              flexDirection="row"
                                              alignItems="center"
                                              gap="8px">
                                              <Typography
                                                fontSize="14px"
                                                fontWeight="700"
                                                sx={{
                                                  margin:
                                                    '5px 0px 0px 0px !important',
                                                  textTransform: 'capitalize',
                                                }}>
                                                {item?.createdBy?.name}{' '}
                                                <span
                                                  style={{
                                                    color: '#7A7A9D',
                                                    fontWeight: 'normal',
                                                  }}>
                                                  logged -
                                                </span>{' '}
                                                <span
                                                  style={{ color: '#c22027' }}>
                                                  {convertSecondsToTimeString(
                                                    item?.loggedHoursInSeconds
                                                  )}
                                                </span>
                                              </Typography>
                                            </Box>
                                            <Typography
                                              color="#7A7A9D"
                                              fontSize="12px"
                                              fontWeight="normal">
                                              {item?.date
                                                ? moment(item?.date).format(
                                                    'LL'
                                                  )
                                                : 'N/A'}
                                            </Typography>
                                          </Box>
                                          <Box
                                            sx={{
                                              background: '#F6F6F6',
                                              borderRadius: '6px',
                                              padding: '3px 8px',
                                              marginBottom: '8px',
                                              fontSize: '12px',
                                            }}>
                                            {item?.description}
                                          </Box>
                                          <Divider />
                                        </Box>
                                      ))
                                    ) : (
                                      <Typography
                                        color="#7A7A9D"
                                        fontSize="12px"
                                        fontWeight="500"
                                        padding="8px"
                                        textAlign="center">
                                        No logged time available.
                                      </Typography>
                                    )}
                                  </Box>
                                )}

                                {tabValue === 4 && (
                                  <Box className={classes.projLinks}>
                                    {Object.keys(projectLinks).length > 0 ? (
                                      Object.keys(projectLinks).map(
                                        (section) => {
                                          const sectionTitles = {
                                            googleDocLinks: 'Google Doc Links',
                                            figmaLinks: 'Figma Links',
                                            drawIOLinks: 'DrawIO Links',
                                            lowLevelDesign:
                                              'Low Level Design Links',
                                            highLevelDesign:
                                              'High Level Design Links',
                                          };

                                          const sectionTitle =
                                            sectionTitles[section] || 'Links';
                                          const links = projectLinks[section];

                                          return (
                                            <div
                                              key={section}
                                              className="projLinkSec"
                                              style={{ marginBottom: '0px' }}>
                                              <Typography
                                                variant="h6"
                                                style={{
                                                  fontSize: '14px',
                                                  fontWeight: 'bold',
                                                }}>
                                                {sectionTitle}
                                              </Typography>
                                              {links.length > 0 ? (
                                                <ul
                                                  style={{
                                                    // paddingLeft: '15px',
                                                    margin: '5px 0',
                                                  }}>
                                                  {links.map((link, index) => (
                                                    <li
                                                      key={
                                                        link.url ||
                                                        link.label ||
                                                        index
                                                      }
                                                      style={{
                                                        marginBottom: '5px',
                                                        marginTop: '5px',
                                                        height: '25px',
                                                      }}>
                                                      <a
                                                        href={link.url || '#'}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                          // color: '#007bff',
                                                          fontSize: '12px',
                                                        }}>
                                                        {link.label || 'N/A'}
                                                      </a>
                                                    </li>
                                                  ))}
                                                </ul>
                                              ) : (
                                                <Typography
                                                  color="#7A7A9D"
                                                  fontSize="14px"
                                                  fontWeight="500"
                                                  padding="8px"
                                                  textAlign="center">
                                                  No Links available for this
                                                  section.
                                                </Typography>
                                              )}
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <Typography
                                        color="#7A7A9D"
                                        fontSize="14px"
                                        fontWeight="500"
                                        padding="8px"
                                        textAlign="center">
                                        No Links available.
                                      </Typography>
                                    )}
                                  </Box>
                                )}
                              </div>
                            </Card>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={4}
                      className={`${classes.box} ${
                        isDeclineCase ? classes.pointerEvent : ''
                      }`}>
                      <Card className="rightSide">
                        <CardContent>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div className="rightAccordion">
                              <Box
                                display="flex"
                                justifyContent="space-between">
                                <Typography
                                  gutterBottom
                                  variant="h4"
                                  component="div">
                                  Details
                                </Typography>
                                {/* <Select
                                value={caseData?.environment || 'Not ready for Testing'}
                                onChange={(e) => {
                                  updateIndividual('environment', e.target.value);
                                }}
                                sx={{
                                  height: '25px',
                                  fontSize: '12px',
                                }}
                                >
                                  <MenuItem value='Not ready for Testing'>Not ready for Testing</MenuItem>
                                  <MenuItem value='Ready for Acceptance'>Ready for Acceptance</MenuItem>
                                  <MenuItem value='Rejected for Production'>Rejected for Production</MenuItem>
                                  <MenuItem value='Approved for Production'>Approved for Production</MenuItem>
                                  <MenuItem value='Ready for Production'>Ready for Production</MenuItem>
                                </Select> */}
                              </Box>
                              <Divider />
                              <div
                                style={{
                                  display: 'grid',
                                  gridTemplateColumns: '1fr 1fr ',
                                  rowGap: '5px',
                                }}>
                                <Typography fontSize="12px" fontWeight="700">
                                  Case Type
                                </Typography>

                                {isCaseTypeEditMode ? (
                                  <>
                                    <FormControl fullWidth>
                                      <Select
                                        id="case-types"
                                        // disabled={!user?.permissions?.includes('case-update')}
                                        disabled
                                        value={
                                          Object.keys(caseType).length !== 0 &&
                                          caseType?.id
                                        }
                                        onBlur={() => {
                                          setIsCaseTypeEditMode(false);
                                        }}
                                        size="small">
                                        {caseTypeOptions?.map((opt) => (
                                          <MenuItem
                                            value={opt?.id}
                                            data-name={opt?.name}
                                            sx={{
                                              fontSize: '12px !important',
                                            }}>
                                            {opt?.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </>
                                ) : (
                                  <Typography
                                    fontSize="12px"
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-start',
                                    }}>
                                    {caseType?.name || 'Select Case Type'}
                                  </Typography>
                                )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Priority
                                </Typography>
                                {isPriorityEditMode ? (
                                  <FormControl fullWidth>
                                    <Select
                                      id="priorities"
                                      value={
                                        Object.keys(priority).length !== 0 &&
                                        priority?.id
                                      }
                                      disabled={
                                        !user?.permissions?.includes(
                                          'case-update'
                                        )
                                      }
                                      onBlur={() =>
                                        setIsPriorityEditMode(false)
                                      }
                                      onClick={(e) => {
                                        if (
                                          user?.permissions?.includes(
                                            'case-update'
                                          ) &&
                                          e
                                        ) {
                                          const getTarget: any = e.target;
                                          const dataName =
                                            getTarget?.getAttribute(
                                              'data-name'
                                            );
                                          const dataValue =
                                            getTarget?.getAttribute(
                                              'data-value'
                                            );
                                          if (dataValue !== null) {
                                            setPriority({
                                              ...priority,
                                              id: dataValue,
                                              name: dataName,
                                            });
                                            updateIndividual('priority', {
                                              ...priority,
                                              id: dataValue,
                                              name: dataName,
                                            });
                                          }
                                        }
                                        setIsPriorityEditMode(false);
                                      }}
                                      sx={{
                                        height: '25px',
                                        fontSize: '12px',
                                      }}
                                      size="small">
                                      {priorityAllOptions?.map((opt) => (
                                        <MenuItem
                                          key={opt?.id}
                                          value={opt?.id}
                                          data-name={opt?.name}
                                          sx={{ fontSize: '12px !important' }}>
                                          {opt?.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                ) : (
                                  <Typography
                                    fontSize="12px"
                                    fontWeight="700"
                                    sx={{
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                    onClick={() => setIsPriorityEditMode(true)}>
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        width: '8px',
                                        height: '8px',
                                        borderRadius: '50%',
                                        backgroundColor: getColor(
                                          priority?.name || ''
                                        ),
                                        marginRight: '8px',
                                      }}
                                    />
                                    {priority?.name || 'Select Priority'}
                                  </Typography>
                                )}

                                {caseData?.caseType?.name ===
                                  'Application Bug' && (
                                  <Typography fontSize="12px" fontWeight="700">
                                    Severity
                                  </Typography>
                                )}
                                {isSeverityEditMode ? (
                                  <>
                                    {caseData?.caseType?.name ===
                                      'Application Bug' && (
                                      <div className=" labelsDataCss">
                                        <Autocomplete
                                          id="severities"
                                          options={allSeverities || []}
                                          value={severity}
                                          onBlur={() => {
                                            setIsSeverityEditMode(false);
                                          }}
                                          onChange={(
                                            event: any,
                                            value: any
                                          ) => {
                                            if (value !== null) {
                                              setFieldValue('severity', value);
                                              updateIndividual(
                                                'severity',
                                                value
                                              );
                                              setIsSeverityEditMode(false);
                                            }
                                          }}
                                          getOptionLabel={(option) =>
                                            option?.name
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              variant="outlined"
                                              placeholder="Severity*"
                                              InputProps={{
                                                ...params.InputProps,
                                                sx: {
                                                  height: '25px !important',
                                                  '& input': {
                                                    fontSize: '12px',
                                                    height: 'auto !important',
                                                  },
                                                },
                                              }}
                                            />
                                          )}
                                        />
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {caseData?.caseType?.name ===
                                    'Application Bug' ? (
                                      <Box maxWidth="100px" maxHeight="20px">
                                        <Chip
                                          sx={{
                                            height: '100%',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: getColor(
                                              severity?.name || ''
                                            ),
                                            color: 'white',
                                            textShadow: '2px black',
                                            '&:hover': {
                                              backgroundColor: getColor(
                                                severity?.name || ''
                                              ),
                                            },
                                            '& .MuiChip-labelSmall': {
                                              paddingLeft: '5px !important',
                                              paddingRight: '5px !important',
                                            },
                                          }}
                                          onClick={() =>
                                            setIsSeverityEditMode(true)
                                          }
                                          label={severity?.name || '-'}
                                          size="small"
                                        />
                                      </Box>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                                <Typography fontSize="12px" fontWeight="700">
                                  Assignee
                                </Typography>
                                {isAssigneeEditMode ? (
                                  <>
                                    <Autocomplete
                                      id="assigneeID"
                                      options={
                                        allInternalUsers?.length === 0
                                          ? []
                                          : allInternalUsers
                                      }
                                      onChange={(event: any, value: any) => {
                                        setFieldValue('assigneeID', {
                                          id: value?.id,
                                          name: value?.name,
                                        });
                                        updateIndividual('assignee', {
                                          ...assigneeId,
                                          name: value?.name,
                                          id: value?.id,
                                        });
                                        setIsAssigneeEditMode(false);
                                      }}
                                      getOptionLabel={(option) =>
                                        Object.keys(option).length !== 0 &&
                                        option?.name
                                      }
                                      inputValue={
                                        hasMultipleNulls
                                          ? ''
                                          : Object.keys(assigneeId).length !==
                                              0 && assigneeId?.name
                                      }
                                      onBlur={() => {
                                        setIsAssigneeEditMode(false);
                                      }}
                                      onInputChange={(
                                        event: any,
                                        newInputValue: any
                                      ) => {
                                        if (event) {
                                          setAssigneeId({
                                            ...assigneeId,
                                            name: newInputValue,
                                          });
                                        }
                                      }}
                                      disabled={
                                        !user?.permissions?.includes(
                                          'case-update'
                                        )
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                              height: '25px !important',
                                              '& input': {
                                                fontSize: '12px',
                                                height: 'auto !important',
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </>
                                ) : (
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    alignItems="center"
                                    gap="10px"
                                    onClick={() => {
                                      setIsAssigneeEditMode(true);
                                    }}
                                    style={{
                                      fontSize: '12px',
                                      // fontWeight: '600',
                                    }}>
                                    {/* <Avatar sx={{ width: 20, height: 20 }} /> */}
                                    {assigneeId?.name}
                                  </Box>
                                )}

                                <Typography
                                  fontSize="12px"
                                  fontWeight="700"
                                  // onClick={(e) => navigate(`bulk-change/${values?.projectId?.name}/${values?.projectId?.id}`)}
                                >
                                  Project
                                </Typography>
                                {isProjectEditable ? (
                                  <>
                                    <TextField
                                      id="outlined-project"
                                      value={values?.projectId?.name}
                                      onBlur={() => {
                                        setIsProjectEditable(false);
                                      }}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                      variant="outlined"
                                      fullWidth
                                    />
                                  </>
                                ) : (
                                  <Typography
                                    fontSize="12px"
                                    fontWeight="700"
                                    sx={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      // setIsProjectEditable(true)
                                      e.preventDefault();
                                      navigate(
                                        `/erp/cases/bulk-change/${values?.projectId?.name}/${values?.projectId?.id}?key=project-change?caseId=${caseData?.id}`
                                      );
                                    }}>
                                    {values?.projectId?.name}
                                  </Typography>
                                )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Organization
                                </Typography>
                                {isOrganizationEditable ? (
                                  <>
                                    <TextField
                                      id="outlined-select-organization"
                                      value={values?.orgId?.name}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                      onBlur={() => {
                                        setIsOrganizationEditable(false);
                                      }}
                                      variant="outlined"
                                      fullWidth
                                    />
                                  </>
                                ) : (
                                  <Typography
                                    fontSize="12px"
                                    fontWeight="700"
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      // setIsProjectEditable(true)
                                    }}>
                                    {values?.orgId?.name}
                                  </Typography>
                                )}
                                <Typography fontSize="12px" fontWeight="700">
                                  Sponsers
                                </Typography>

                                <Box
                                  display="flex"
                                  flexDirection="row"
                                  gap="5px">
                                  {values?.sponsorId?.map((chip) => (
                                    <Chip
                                      key={chip?.id}
                                      label={chip?.name}
                                      size="small"
                                      sx={{
                                        fontSize: '12px',
                                        marginRight: '0px',
                                        marginBottom: '0px',
                                        maxWidth: '150px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        cursor: 'no-drop',
                                        '& .MuiChip-labelSmall': {
                                          paddingLeft: '5px !important',
                                          paddingRight: '5px !important',
                                        },
                                      }}
                                    />
                                  ))}
                                </Box>

                                <Typography fontSize="12px" fontWeight="700">
                                  Stakeholder
                                </Typography>
                                {isStakeholderEditMode ? (
                                  <>
                                    <Autocomplete
                                      id="stakeHolderId-name"
                                      multiple
                                      disableClearable
                                      limitTags={1}
                                      options={
                                        allStakeholders?.length === 0
                                          ? []
                                          : allStakeholders?.filter(
                                              (itm1) =>
                                                !values?.stakeHolderId?.some(
                                                  (itm2) =>
                                                    itm1?.id === itm2?.id
                                                )
                                            )
                                      }
                                      onChange={(event: any, value: any) => {
                                        if (event) {
                                          // updateIndividual('stakeHolder', [...values?.stakeHolderId, ...value]);
                                          updateIndividual(
                                            'stakeHolder',
                                            value
                                          );
                                          setIsStakeholderEditMode(false);
                                        }
                                      }}
                                      onBlur={() => {
                                        setIsStakeholderEditMode(false);
                                      }}
                                      value={values?.stakeHolderId}
                                      getOptionLabel={(option) =>
                                        Object.keys(option)?.length !== 0 &&
                                        option?.name
                                      }
                                      inputValue={stakeholderInput}
                                      disabled={
                                        !user?.permissions?.includes(
                                          'case-update'
                                        )
                                      }
                                      onInputChange={(
                                        event: any,
                                        newInputValue: any
                                      ) => {
                                        if (event) {
                                          setStakeholderInput(newInputValue);
                                        }
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          // sx={{marginTop: '5px',}}
                                          // placeholder="Add Stakeholder"
                                          sx={{
                                            '& .MuiOutlinedInput-root': {
                                              height: 'auto !important', // Set height to auto here
                                              minHeight: '25px !important', // Keep your minimum height
                                              '& .MuiInputBase-input': {
                                                fontSize: '12px',
                                                height: 'auto !important',
                                              },
                                              '& .MuiChip-root': {
                                                fontSize: '12px',
                                                height: '18px !important',
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </>
                                ) : (
                                  <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="flex-start"
                                    gap="10px"
                                    onClick={() => {
                                      setIsStakeholderEditMode(true);
                                    }}>
                                    {values?.stakeHolderId
                                      ?.slice(0, 1)
                                      .map((stakeholder) => (
                                        <Box
                                          key={stakeholder.id}
                                          display="flex"
                                          flexDirection="row"
                                          alignItems="center"
                                          gap="10px"
                                          sx={{
                                            fontSize: '12px',
                                          }}>
                                          {stakeholder.name}{' '}
                                          {values?.stakeHolderId.length >=
                                            2 && (
                                            <>
                                              +
                                              {values?.stakeHolderId.length - 1}{' '}
                                              more
                                            </>
                                          )}{' '}
                                        </Box>
                                      ))}
                                  </Box>
                                )}
                                <Typography fontSize="12px" fontWeight="700">
                                  Collaborators
                                </Typography>
                                {isCollaboratorEditMode ? (
                                  <>
                                    <Autocomplete
                                      id="collaborators-name"
                                      multiple
                                      disableClearable
                                      disableCloseOnSelect
                                      limitTags={1}
                                      options={
                                        allInternalUsers?.length === 0
                                          ? []
                                          : allInternalUsers.filter(
                                              (userVAl) =>
                                                !values?.collaborators.some(
                                                  (selected) =>
                                                    selected.id === userVAl.id
                                                )
                                            )
                                      }
                                      onChange={(event: any, value: any) => {
                                        if (event) {
                                          // updateIndividual('stakeHolder', [...values?.stakeHolderId, ...value]);
                                          updateIndividual(
                                            'collaborators',
                                            value
                                          );
                                          // setIsCollaboratorEditMode(false);
                                        }
                                      }}
                                      onBlur={() => {
                                        setIsCollaboratorEditMode(false);
                                      }}
                                      value={values?.collaborators}
                                      getOptionLabel={(option) =>
                                        Object.keys(option)?.length !== 0 &&
                                        option?.name
                                      }
                                      inputValue={collaboratorInput}
                                      disabled={
                                        !user?.permissions?.includes(
                                          'case-update'
                                        )
                                      }
                                      onInputChange={(
                                        event: any,
                                        newInputValue: any
                                      ) => {
                                        if (event) {
                                          setCollaboratorInput(newInputValue);
                                        }
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          // sx={{marginTop: '5px',}}
                                          // placeholder="Add Stakeholder"
                                          sx={{
                                            '& .MuiOutlinedInput-root': {
                                              height: 'auto !important', // Set height to auto here
                                              minHeight: '25px !important', // Keep your minimum height
                                              '& .MuiInputBase-input': {
                                                fontSize: '12px',
                                                height: 'auto !important',
                                              },
                                              '& .MuiChip-root': {
                                                fontSize: '12px',
                                                height: '18px !important',
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </>
                                ) : (
                                  <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="flex-start"
                                    gap="10px"
                                    onClick={() => {
                                      setIsCollaboratorEditMode(true);
                                    }}>
                                    {values?.collaborators
                                      ?.slice(0, 1)
                                      .map((collaborator) => (
                                        <Box
                                          key={collaborator.id}
                                          display="flex"
                                          flexDirection="row"
                                          alignItems="center"
                                          gap="10px"
                                          sx={{
                                            fontSize: '12px',
                                          }}>
                                          {collaborator.name}{' '}
                                          {values?.collaborators.length >=
                                            2 && (
                                            <>
                                              +
                                              {values?.collaborators.length - 1}{' '}
                                              more
                                            </>
                                          )}{' '}
                                        </Box>
                                      ))}
                                  </Box>
                                )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Escalation Manager
                                </Typography>
                                {isEscalationManagerEditMode ? (
                                  <>
                                    <Autocomplete
                                      id="escalation-manager"
                                      options={
                                        allInternalUsers?.length === 0
                                          ? []
                                          : allInternalUsers
                                      }
                                      getOptionLabel={(option) =>
                                        Object.keys(option).length !== 0 &&
                                        option?.name
                                      }
                                      onChange={(event: any, value: any) => {
                                        setEscalationManagerId(value);
                                        updateIndividual('escalationManager', {
                                          ...escalationManagerId,
                                          id: value?.id,
                                          name: value?.name,
                                        });
                                        setIsEscalationManagerEditMode(false);
                                      }}
                                      inputValue={escalationManagerInput}
                                      onInputChange={(
                                        event: any,
                                        newInputValue: any
                                      ) => {
                                        setEscalationManagerInput(
                                          newInputValue
                                        );
                                      }}
                                      onBlur={() => {
                                        setIsEscalationManagerEditMode(false);
                                      }}
                                      disabled={
                                        caseData?.escalationManager?.id ===
                                          '' ||
                                        caseData?.escalationManager?.id ===
                                          null ||
                                        caseData?.escalationManager?.id ===
                                          undefined ||
                                        !user?.permissions?.includes(
                                          'case-update'
                                        )
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          name="escalationManagerIds"
                                          InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                              height: '25px !important',
                                              '& input': {
                                                fontSize: '12px',
                                                height: 'auto !important',
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </>
                                ) : (
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    alignItems="center"
                                    gap="10px"
                                    onClick={() => {
                                      setIsEscalationManagerEditMode(true);
                                    }}
                                    sx={{
                                      fontSize: '12px',
                                    }}>
                                    {/* <Avatar sx={{ width: 20, height: 20 }} /> */}
                                    {escalationManagerId?.name || '-'}
                                  </Box>
                                )}

                                {caseData?.isApprovalRequired &&
                                  caseData?.caseType?.name ===
                                    'Application Feature Request' &&
                                  caseData?.isApproved === true && (
                                    <>
                                      <Typography
                                        fontSize="12px"
                                        fontWeight="700">
                                        Approved
                                      </Typography>
                                      <Typography fontSize="12px">
                                        {caseData?.isApproved === true
                                          ? 'Yes'
                                          : 'No'}
                                      </Typography>
                                      <Typography
                                        fontSize="12px"
                                        fontWeight="700">
                                        Approved Date
                                      </Typography>
                                      <Typography fontSize="12px">
                                        {moment(
                                          caseData?.approvedDate
                                        ).isValid()
                                          ? moment(
                                              caseData?.approvedDate
                                            ).format('YYYY-MM-DD')
                                          : 'N/A'}
                                      </Typography>
                                    </>
                                  )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Sprints
                                </Typography>
                                {isSprintsEditable ? (
                                  <Autocomplete
                                    options={sprints || []}
                                    value={currentSprint || null}
                                    // eslint-disable-next-line consistent-return
                                    onChange={(event: any, value: any) => {
                                      setCurrentSprint(value);
                                      updateIndividual('sprint', value);
                                      setIsSprintsEditable(false);
                                    }}
                                    getOptionLabel={(option) =>
                                      option?.name || ''
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="sprint"
                                        placeholder="Sprint"
                                        InputProps={{
                                          ...params.InputProps,
                                          sx: {
                                            height: '25px !important',
                                            '& input': {
                                              fontSize: '12px',
                                              height: 'auto !important',
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                ) : (
                                  <Typography
                                    fontSize="12px"
                                    onClick={() => {
                                      setIsSprintsEditable(true);
                                    }}>
                                    {currentSprint?.name || 'N/A'}
                                  </Typography>
                                )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Fix Versions
                                </Typography>
                                {isFixVersionEditable ? (
                                  <Autocomplete
                                    options={allFixVersions || []}
                                    onChange={(event: any, value: any) => {
                                      setReleaseVersion(value);
                                      updateIndividual('releaseVersion', [
                                        value,
                                      ]);
                                      setIsFixVersionEditable(false);
                                    }}
                                    getOptionLabel={(option) => option?.name}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="releaseVersion"
                                        placeholder="Release Version"
                                        InputProps={{
                                          ...params.InputProps,
                                          sx: {
                                            height: '25px !important',
                                            '& input': {
                                              fontSize: '12px',
                                              height: 'auto !important',
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                ) : (
                                  <Typography
                                    fontSize="12px"
                                    onClick={() => {
                                      setIsFixVersionEditable(true);
                                    }}>
                                    {releaseVersion?.length > 0
                                      ? releaseVersion[0]?.name
                                      : 'N/A'}{' '}
                                  </Typography>
                                )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Labels
                                </Typography>
                                {isLabelEditable ? (
                                  <>
                                    <Autocomplete
                                      multiple
                                      options={labelsOptions}
                                      disableCloseOnSelect
                                      limitTags={1}
                                      value={labelsData}
                                      onChange={(e: any, newValue: any) => {
                                        if (e && newValue) {
                                          setLabelsData(newValue);
                                          updateIndividual('labels', newValue);
                                          // setIsLabelEditable(false);
                                        }
                                      }}
                                      onBlur={() => {
                                        setIsLabelEditable(false);
                                      }}
                                      inputValue={labelInputValue}
                                      onInputChange={(
                                        event: any,
                                        newInputValue: any
                                      ) => {
                                        if (event) {
                                          setLabelInputValue(newInputValue);
                                        }
                                      }}
                                      disabled={
                                        !user?.permissions?.includes(
                                          'case-update'
                                        )
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label=""
                                          variant="outlined"
                                          name="labelsId"
                                          sx={{
                                            '& .MuiOutlinedInput-root': {
                                              height: 'auto !important', // Set height to auto here
                                              minHeight: '25px !important', // Keep your minimum height
                                              '& .MuiInputBase-input': {
                                                fontSize: '12px',
                                                height: 'auto !important',
                                              },
                                              '& .MuiChip-root': {
                                                fontSize: '12px',
                                                height: '18px !important',
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </>
                                ) : (
                                  <>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="flex-start"
                                      gap="10px"
                                      onClick={() => {
                                        setIsLabelEditable(true);
                                      }}>
                                      {labelsData?.slice(0, 1).map((item) => (
                                        <Box
                                          key={item}
                                          display="flex"
                                          flexDirection="row"
                                          alignItems="center"
                                          gap="10px"
                                          sx={{
                                            fontSize: '12px',
                                          }}>
                                          {item}{' '}
                                          {labelsData?.length >= 2 && (
                                            <>+{labelsData?.length - 1} more</>
                                          )}{' '}
                                        </Box>
                                      ))}
                                    </Box>
                                  </>
                                )}

                                <Box>
                                  <Typography fontSize="12px" fontWeight="700">
                                    Module
                                  </Typography>
                                </Box>
                                <Box className="moduleListClass">
                                  {moduleEditable ? (
                                    <Autocomplete
                                      value={
                                        moduleValue?.split('-')[0]
                                          ? moduleValue
                                              ?.split('- ')
                                              .slice(1)
                                              .join('')
                                          : moduleValue || ''
                                      }
                                      onChange={(event, newValue: any) => {
                                        if (typeof newValue === 'string') {
                                          let newModule = newValue;
                                          if (
                                            !newValue.includes(
                                              project?.name?.split('-')[0]
                                            )
                                          ) {
                                            newModule = `${project?.name?.split(
                                              '-'
                                            )} - ${newValue}`;
                                          }
                                          setModuleValue(newValue);
                                          updateIndividual(
                                            'module',
                                            `${newModule}`
                                          );
                                          try {
                                            projectModulesApi.createModule({
                                              orgId: organization.id,
                                              projectId: project.id,
                                              name: newModule,
                                            });
                                            getAllModules();
                                          } catch (error) {
                                            toast.error(
                                              error.message ??
                                                'Error while adding module'
                                            );
                                          }
                                          setModuleEditable(false);
                                        }
                                      }}
                                      filterOptions={(options, params) => {
                                        const filtered = options.filter(
                                          (option) =>
                                            option
                                              .toLowerCase()
                                              .includes(
                                                params.inputValue.toLowerCase()
                                              )
                                        );

                                        const { inputValue } = params;
                                        const isExisting = options.some(
                                          (option) =>
                                            option.toLowerCase() ===
                                            inputValue.toLowerCase()
                                        );

                                        if (inputValue !== '' && !isExisting) {
                                          setDebouncedValue(inputValue); // Trigger debounce logic
                                          filtered.push(`${inputValue}`);
                                        }

                                        return Array.from(new Set(filtered));
                                      }}
                                      selectOnFocus
                                      handleHomeEndKeys
                                      freeSolo
                                      options={moduleList || []}
                                      getOptionLabel={(option) => option}
                                      renderOption={(props, option) => (
                                        <li {...props}>{option}</li>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Module List"
                                          InputProps={{
                                            ...params.InputProps,
                                            startAdornment: project && (
                                              <InputAdornment position="start">
                                                <Typography
                                                  sx={{
                                                    color: '#666',
                                                    fontSize: '12px',
                                                  }}>
                                                  {project?.name?.split('-')} -
                                                </Typography>
                                              </InputAdornment>
                                            ),
                                            sx: {
                                              height: '25px !important',
                                              '& input': {
                                                fontSize: '12px',
                                                height: 'auto !important',
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  ) : (
                                    <>
                                      <Typography
                                        fontSize="12px"
                                        onClick={() => {
                                          setModuleEditable(true);
                                        }}>
                                        {/* {!isEmpty(moduleEditable)
                                        ? caseData?.module ||
                                        'N/A'
                                        : 'N/A'} */}

                                        {caseData?.module || 'N/A'}
                                      </Typography>
                                    </>
                                  )}
                                </Box>
                                <Typography fontSize="12px" fontWeight="700">
                                  Expense
                                </Typography>
                                {isBillingEditable ? (
                                  <>
                                    <Autocomplete
                                      id="caseAccountBilling-type"
                                      onBlur={() => {
                                        setIsBillingEditable(false);
                                      }}
                                      options={[
                                        {
                                          id: 'Opex',
                                          name: 'Opex',
                                        },
                                        {
                                          id: 'Capex',
                                          name: 'Capex',
                                        },
                                      ]}
                                      value={billingType}
                                      onChange={(event: any, value: any) => {
                                        if (value !== null) {
                                          setBillingType(value);
                                          updateIndividual(
                                            'expense',
                                            value?.id
                                          );
                                        }
                                        setIsBillingEditable(false);
                                      }}
                                      getOptionLabel={(option) => option?.name}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="expense"
                                          variant="outlined"
                                          placeholder="Billing Type*"
                                          InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                              height: '25px !important',
                                              '& input': {
                                                fontSize: '12px',
                                                height: 'auto !important',
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </>
                                ) : (
                                  <Box
                                    sx={{
                                      display: 'inline-flex',
                                    }}
                                    maxWidth="150px">
                                    <Typography
                                      fontSize="12px"
                                      color={
                                        billingType?.name === 'Opex'
                                          ? '#828282'
                                          : '#EB5757'
                                      }
                                      fontWeight="700"
                                      sx={{
                                        cursor: 'pointer',
                                        backgroundColor:
                                          billingType?.name === 'Opex'
                                            ? '#E8E8E8'
                                            : '#FFEDE3',
                                        padding: '0px 4px',
                                        borderRadius: '4px',
                                      }}
                                      onClick={() =>
                                        setIsBillingEditable(true)
                                      }>
                                      {billingType?.name || 'N/A'}
                                    </Typography>
                                  </Box>
                                )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Start Date
                                </Typography>

                                {isStartDateEditable ? (
                                  <>
                                    <TextField
                                      value={moment(startDate).format(
                                        'YYYY-MM-DD'
                                      )}
                                      onChange={handleStartDateChange}
                                      onBlur={() => {
                                        setIsStartDateEditable(false);
                                        updateIndividual(
                                          'startDate',
                                          startDate
                                        );
                                      }}
                                      size="small"
                                      fullWidth
                                      type="date"
                                      className={classes.datePicker}
                                      InputProps={{
                                        sx: {
                                          height: '25px',
                                          fontSize: '12px',
                                        },
                                      }}
                                    />
                                  </>
                                ) : (
                                  <Box
                                    sx={{
                                      display: 'inline-flex',
                                    }}
                                    maxWidth="150px">
                                    <Typography
                                      fontSize="12px"
                                      fontWeight="700"
                                      sx={{ cursor: 'pointer' }}
                                      onClick={() =>
                                        setIsStartDateEditable(true)
                                      }>
                                      <Typography fontSize="12px">
                                        {startDate || 'N/A'}
                                      </Typography>
                                    </Typography>
                                  </Box>
                                )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Due Date
                                </Typography>
                                {isDueDateEditable ? (
                                  <>
                                    <TextField
                                      value={moment(dueDate).format(
                                        'YYYY-MM-DD'
                                      )}
                                      onChange={handleDueDateChange}
                                      onBlur={() => {
                                        setIsDueDateEditable(false);
                                        updateIndividual('dueDate', dueDate);
                                      }}
                                      size="small"
                                      fullWidth
                                      type="date"
                                      className={classes.datePicker}
                                      InputProps={{
                                        sx: {
                                          height: '25px',
                                          fontSize: '12px',
                                        },
                                      }}
                                    />
                                  </>
                                ) : (
                                  <Box
                                    sx={{
                                      display: 'inline-flex',
                                    }}
                                    maxWidth="150px">
                                    <Typography
                                      fontSize="12px"
                                      fontWeight="700"
                                      sx={{ cursor: 'pointer' }}
                                      onClick={() =>
                                        setIsDueDateEditable(true)
                                      }>
                                      <Typography fontSize="12px">
                                        {dueDate || 'N/A'}
                                      </Typography>
                                    </Typography>
                                  </Box>
                                )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Time Estimate
                                </Typography>

                                {isTimeEstimateEditable ? (
                                  <TextField
                                    id="outlined-project"
                                    value={timeEstimate}
                                    onBlur={() => {
                                      setIsTimeEstimateEditable(false);
                                      updateIndividual(
                                        'timeEstimate',
                                        convertToSeconds(timeEstimate)
                                      );
                                    }}
                                    onChange={(e) => {
                                      setTimeEstimate(e.target.value);
                                    }}
                                    InputProps={{
                                      sx: {
                                        height: '25px',
                                        fontSize: '12px',
                                      },
                                    }}
                                    variant="outlined"
                                    fullWidth
                                  />
                                ) : (
                                  <Typography
                                    fontSize="12px"
                                    onClick={() => {
                                      setIsTimeEstimateEditable(true);
                                    }}>
                                    {timeEstimate || '0h'}
                                  </Typography>
                                )}
                                <Typography fontSize="12px" fontWeight="700">
                                  Account
                                </Typography>
                                {billingAccountTypeEditable ? (
                                  <Autocomplete
                                    options={billingAccounts}
                                    value={
                                      billingAccountType
                                        ? billingAccounts?.find(
                                            (item) =>
                                              item?._id ===
                                              billingAccountType?.id
                                          ) || null
                                        : null
                                    }
                                    onChange={(event: any, value: any) => {
                                      handleBillingAccountChange(value);
                                    }}
                                    getOptionLabel={(option) =>
                                      option?.name || ''
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                      option?._id === value?._id
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="billingAccountType"
                                        placeholder="Account"
                                        InputProps={{
                                          ...params.InputProps,
                                          sx: {
                                            height: '25px !important',
                                            '& input': {
                                              fontSize: '12px',
                                              height: 'auto !important',
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                ) : (
                                  <Typography
                                    fontSize="12px"
                                    onClick={() => {
                                      setBillingAccountTypeEditable(true);
                                    }}>
                                    {!isEmpty(billingAccountType)
                                      ? caseData?.billingAccountType?.name ||
                                        'N/A'
                                      : 'N/A'}
                                  </Typography>
                                )}

                                <Typography fontSize="12px" fontWeight="700">
                                  Case Owner / Reporter
                                </Typography>
                                <Typography fontSize="12px" fontWeight="700">
                                  {values?.caseOwner}
                                </Typography>
                                <Typography fontSize="12px" fontWeight="700">
                                  Environment
                                </Typography>
                                {isEnvironmentEditable ? (
                                  <Select
                                    value={
                                      caseData?.environment ||
                                      'Local (Not ready for testing)'
                                    }
                                    onChange={(e) => {
                                      updateIndividual(
                                        'environment',
                                        e.target.value
                                      );
                                      setIsEnvironmentEditable(false);
                                    }}
                                    onBlur={() =>
                                      setIsEnvironmentEditable(false)
                                    }
                                    sx={{
                                      height: '25px',
                                      fontSize: '12px',
                                    }}>
                                    <MenuItem value="Local (Not ready for testing)">
                                      Local (Not ready for testing)
                                    </MenuItem>
                                    <MenuItem value="Development">
                                      Development
                                    </MenuItem>
                                    <MenuItem value="Acceptance">
                                      Acceptance
                                    </MenuItem>
                                    <MenuItem value="Testing">Testing</MenuItem>
                                    <MenuItem value="Production">
                                      Production
                                    </MenuItem>
                                  </Select>
                                ) : (
                                  <Typography
                                    fontSize="12px"
                                    onClick={() =>
                                      setIsEnvironmentEditable(true)
                                    }
                                    sx={{ cursor: 'pointer' }}>
                                    {caseData?.environment ||
                                      'Local (Not ready for testing)'}
                                  </Typography>
                                )}
                              </div>
                            </div>
                            {/* {user?.permissions?.includes(
                              'case-escalate-read'
                            ) && (
                                <div className="rightAccordion">
                                  <Typography
                                    gutterBottom
                                    variant="h4"
                                    component="div">
                                    Escalate
                                  </Typography>
                                  <div className="jiraSync">
                                    {caseData?.escalations?.length ? (
                                      caseData?.escalations?.map(
                                        (escalation: any) => (
                                          <div>
                                            <span>
                                              <b>
                                                {escalation?.escalatedBy?.name}
                                              </b>
                                            </span>{' '}
                                            <span>has escalated on </span>{' '}
                                            <span>
                                              {time.absoluteTime(
                                                escalation?.createdAt
                                              )}
                                            </span>
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <Button
                                        variant="contained"
                                        color="secondary"
                                        className={classes.button}
                                        startIcon={<SwapVerticalCircleIcon />}
                                        onClick={escalateById}>
                                        Escalate
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              )} */}

                            {/* <div className="rightAccordion">
                              <Typography
                                gutterBottom
                                variant="h4"
                                component="div"
                                sx={{ marginBottom: '4px' }}>
                                SLAs
                              </Typography>
                              <div className="caseRightInner">
                                <div className="sLa">
                                  <span
                                    className={`${caseData?.sla?.isResolveTimeViolated ===
                                      true
                                      ? 'bgRed'
                                      : ''
                                      } btnTime`}>
                                    {caseData?.sla?.actualTime?.resolveTime !==
                                      null &&
                                      moment(
                                        caseData?.sla?.actualTime?.resolveTime
                                      ).format('MMM Do hh:mm')}{' '}
                                    <QueryBuilderIcon />
                                  </span>
                                  <span className="resolveTime">
                                    Time to resolution
                                    <p>
                                      {`before ${time.absoluteTime(
                                        caseData?.sla?.estimatedTime
                                          ?.resolveTime
                                      )}`}
                                    </p>
                                  </span>
                                </div>
                              </div>
                              <div className="caseRightInner">
                                <div className="sLa">
                                  <span
                                    className={`${caseData?.sla
                                      ?.isFirstResponseTimeViolated === true
                                      ? 'bgRed'
                                      : ''
                                      } btnTimeFirst`}>
                                    {caseData?.sla?.actualTime
                                      ?.firstResponseTime !== null &&
                                      moment(
                                        caseData?.sla?.actualTime
                                          ?.firstResponseTime
                                      ).format('MMM Do hh:mm')}{' '}
                                    <ClearIcon />
                                  </span>
                                  <span className="resolveTime">
                                    Time to first response
                                    <p>
                                      {`before ${time.absoluteTime(
                                        caseData?.sla?.estimatedTime
                                          ?.firstResponseTime
                                      )}`}
                                    </p>
                                  </span>
                                </div>
                              </div>
                            </div> */}

                            {/* <div className="rightAccordion">

                            </div> */}
                            <div
                              className="createdAt"
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '10px',
                              }}>
                              <p
                                title={moment(caseData?.createdAt).format(
                                  'MMM DD YYYY - HH:mm:ss'
                                )}
                                style={{
                                  fontSize: '12px',
                                }}>
                                Created:{' '}
                                <span>
                                  {/* {time.absoluteTime(caseData?.createdAt)} */}
                                  {moment(caseData?.createdAt).format(
                                    'DD MMM, YYYY HH:mm:ss'
                                  )}
                                </span>
                              </p>
                              <p
                                title={moment(caseData?.updatedAt).format(
                                  'MMM DD YYYY - HH:mm:ss'
                                )}
                                style={{
                                  fontSize: '12px',
                                }}>
                                Updated:{' '}
                                <span>
                                  {time.absoluteTime(caseData?.updatedAt)}
                                </span>
                              </p>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                      <Card style={{ marginTop: '10px' }}>
                        <CardContent sx={{ paddingBottom: '5px !important' }}>
                          <div className="orgInfo">
                            <Typography
                              gutterBottom
                              variant="h5"
                              sx={{ fontWeight: 'bold', fontSize: '14px' }}
                              component="div">
                              Case Documents
                            </Typography>
                            <Divider />
                            <Typography
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                marginTop: '1rem',
                              }}
                              variant="h5">
                              Google Doc Links
                            </Typography>
                            <MultiFileLinkInputCase
                              placeholder="Google Doc Link"
                              labelPlaceholder="Google Doc Label"
                              inputs={googleDocLinks}
                              onAddInput={handleAddGoogleDocLinks}
                              onRemoveInput={(id) =>
                                handleRemoveGoogleDocLinks(id)
                              }
                              onInputChange={(id, event) =>
                                setGoogleDocLinks(
                                  googleDocLinks.map((input) =>
                                    input.id === id
                                      ? { ...input, value: event.target.value }
                                      : input
                                  )
                                )
                              }
                              onLabelChange={(id, event) =>
                                setGoogleDocLinks(
                                  googleDocLinks.map((input) =>
                                    input.id === id
                                      ? { ...input, label: event.target.value }
                                      : input
                                  )
                                )
                              }
                              mainClassName="multiFileInputContainer"
                              inputClassName={classes.inputClassName}
                              labelClassName={classes.labelClassName}
                            />
                          </div>
                          <div className="orgInfo">
                            <Typography
                              style={{ fontSize: '12px', fontWeight: '600' }}
                              variant="h5">
                              Figma Links
                            </Typography>
                            <MultiFileLinkInputCase
                              placeholder="Figma Link"
                              labelPlaceholder="Figma Label"
                              inputs={figmaLinks}
                              onAddInput={handleAddFigmaLinks}
                              onRemoveInput={(id) => handleRemoveFigmaLinks(id)}
                              onInputChange={(id, event) =>
                                setFigmaLinks(
                                  figmaLinks.map((input) =>
                                    input.id === id
                                      ? { ...input, value: event.target.value }
                                      : input
                                  )
                                )
                              }
                              onLabelChange={(id, event) =>
                                setFigmaLinks(
                                  figmaLinks.map((input) =>
                                    input.id === id
                                      ? { ...input, label: event.target.value }
                                      : input
                                  )
                                )
                              }
                              mainClassName="multiFileInputContainer"
                              inputClassName={classes.inputClassName}
                              labelClassName={classes.labelClassName}
                            />
                          </div>
                        </CardContent>
                      </Card>
                      <Card style={{ marginTop: '10px' }}>
                        <CardContent sx={{ paddingBottom: '5px !important' }}>
                          <div className="orgInfo">
                            <Typography
                              gutterBottom
                              variant="h5"
                              sx={{ fontWeight: 'bold', fontSize: '14px' }}
                              component="div">
                              Link Cases
                            </Typography>
                            <Divider />
                            {/* {console.log('inputs-LinkCasess',inputs)} */}
                            <LinkCases
                              inputs={inputs}
                              onAddInput={handleAddInput}
                              onRemoveInput={handleRemoveInput}
                              onInputChange={handleInputChange}
                              onLabelChange={handleLabelChange}
                              caseKey={caseData?.caseKey}
                              labelOptions={labelOptions}
                              valueOptions={allCasesData}
                              placeholder="Search for cases"
                              labelPlaceholder="Choose link type"
                              inputClassName={classes.input_update_active}
                            />
                          </div>
                        </CardContent>
                      </Card>

                      <Card style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <TimeTracking
                          caseData={caseData}
                          totalTime={totalTime}
                          remainingTimePercent={remainingTimePercent}
                          loggedTimePercent={loggedTimePercent}
                          loggedTime={loggedTime}
                          timeEstimate={timeEstimate}
                          handleLogTimeModalOpen={handleLogTimeModalOpen}
                          handleEditLogTimeModalOpen={
                            handleEditLogTimeModalOpen
                          }
                          handleDeleteLogTimeModalOpen={
                            handleDeleteLogTimeModalOpen
                          }
                          convertSecondsToTimeString={
                            convertSecondsToTimeString
                          }
                        />
                      </Card>
                    </Grid>
                  </Grid>

                  <AttachmentViewModal
                    isOpen={isImagePopupOpen}
                    onClose={handleCloseImagePopup}
                    imageUrl={selectedImageUrl}
                  />
                  <LogTimeModal
                    isOpen={logTimeModalOpen}
                    onClose={handleLogTimeModalOpen}
                    billingAccounts={billingAccounts}
                    caseId={caseData?.id}
                    caseKey={caseData?.caseKey}
                    caseSummary={caseData?.summary}
                    loggedTimeEditData={loggedTimeEditData}
                    sprintOptions={sprints}
                    caseSprint={caseData?.sprint}
                    fixVersion={caseData?.releaseVersion}
                    fixVersionOptions={allFixVersions}
                    caseBillingAccount={caseData?.billingAccountType}
                    reloadData={getCaseById}
                    convertSecondsToTimeString={convertSecondsToTimeString}
                  />

                  {openDeleteDialog && (
                    <DeleteLogTimeModal
                      open={openDeleteDialog}
                      onClose={handleDeleteLogTimeModalClose}
                      onConfirm={handleDeleteConfirm}
                      item={selectedLogTime}
                      type="log"
                    />
                  )}

                  {openAttachmentDeleteDialog && (
                    <DeleteLogTimeModal
                      open={openAttachmentDeleteDialog}
                      onClose={handleDeleteAttachmentModalClose}
                      onConfirm={handleDeleteAttachmentConfirm}
                      item={selectedAttachment}
                      type="Attachment"
                    />
                  )}

                  {isDocumentViewerOpen && (
                    <DocumentViewer
                      documentUrl={selectedDocumentUrl}
                      isOpen={isDocumentViewerOpen}
                      onClose={handleCloseDocumentViewer}
                    />
                  )}

                  <BillingAccountDialog
                    open={openBillingAccountDialog}
                    onClose={() => setOpenBillingAccountDialog(false)}
                    onConfirm={handleBillingAccountConfirm}
                    selectedAccount={selectedBillingAccount}
                  />
                  <DeclineDialog
                    open={showDeclineDialog}
                    onClose={() => {
                      setShowDeclineDialog(false);
                      setPendingStatusChange(null);
                    }}
                    onStatusChange={(status) => {
                      setFieldValue('statusId', { id: status.id });
                      return updateIndividual('status', {
                        ...statusInputValue,
                        name: status.name,
                        id: status.id,
                      });
                    }}
                    caseData={caseData}
                    pendingStatus={pendingStatusChange}
                  />
                </form>
              )}
            </Formik>
          </Container>
        </Box>
      }
    </>
  );
}

export default EditCases;
